import PropertyApplicationComments from "../../components/PropertyApplicationComments";
import { getPersonData, getMyInfoData } from "../../utils/myinfoData";
import usePropertyMyinfoProfiles from "../../hooks/usePropertyMyinfoProfiles";
import "../../borrower/profile staging/AuthenticationReview.css";
import React, { useEffect, useMemo, useState } from "react";
import Cookies from "js-cookie";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  PDFDownloadLink,
  Font,
  PDFViewer,
} from "@react-pdf/renderer";
import logo from "../../assets/img/SL-01.png";
import { get } from "lodash";
import GppGoodIcon from "@mui/icons-material/GppGood";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import HistoryEduOutlinedIcon from "@mui/icons-material/HistoryEduOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import { format } from "date-fns";
import SccbPdfViewer from "../../components/SccbPdfViewer";
import BankStatementAnalysisPanel, {
  formatCurrencyAmount,
  getCurrencySummaries,
  getLoanKeywordCount,
  getNegativeBalanceCount,
} from "../../components/BankStatementAnalysisPanel";

const parseSccbReportData = (value) => {
  if (!value) return null;
  if (typeof value === "object") return value;
  try {
    const parser = new DOMParser();
    const xml = parser.parseFromString(value, "application/xml");
    const err = xml.getElementsByTagName("parsererror")[0];
    if (err) throw new Error("Invalid XML");

    const nodeToValue = (node) => {
      const children = Array.from(node.children || []);
      if (!children.length) {
        const text = (node.textContent || "").trim();
        return text === "" ? "" : text;
      }
      const out = {};
      for (const child of children) {
        const key = child.tagName;
        const val = nodeToValue(child);
        if (out[key] === undefined) out[key] = val;
        else if (Array.isArray(out[key])) out[key].push(val);
        else out[key] = [out[key], val];
      }
      return out;
    };

    const report = xml.getElementsByTagName("REPORT")[0];
    return report ? nodeToValue(report) : nodeToValue(xml.documentElement);
  } catch (error) {
    return null;
  }
};

const ensureSccbValue = (value, dash = "—") =>
  value === null || value === undefined || String(value).trim() === ""
    ? dash
    : String(value);

const normalizeSccbList = (value) => {
  if (!value) return [];
  if (Array.isArray(value)) return value;
  if (typeof value === "object") {
    const entries = Object.entries(value);
    for (const [, entryValue] of entries) {
      if (Array.isArray(entryValue)) return entryValue;
    }
    if (entries.length === 1 && entries[0][1]) {
      return Array.isArray(entries[0][1]) ? entries[0][1] : [entries[0][1]];
    }
    return [value];
  }
  return [];
};

const formatSccbColumnLabel = (label) =>
  String(label).replace(/_/g, " ").replace(/\s+/g, " ").trim().toUpperCase();

const normalizeStatementGroupValue = (value, fallback) => {
  if (value === null || value === undefined) return fallback;
  const normalized = String(value).trim();
  return normalized === "" ? fallback : normalized;
};

const getStatementMonthTimestamp = (statement) => {
  const rawValue = normalizeStatementGroupValue(
    statement?.statement_month_year,
    "",
  );

  if (!rawValue) return null;

  const normalizedValue = rawValue.replace(/-/g, "/").trim();
  const mmYyyyMatch = normalizedValue.match(/^(\d{1,2})\/(\d{4})$/);
  if (mmYyyyMatch) {
    const month = Number(mmYyyyMatch[1]) - 1;
    const year = Number(mmYyyyMatch[2]);
    if (month >= 0 && month <= 11) {
      return new Date(year, month, 1).getTime();
    }
  }

  const yyyyMmMatch = normalizedValue.match(/^(\d{4})\/(\d{1,2})$/);
  if (yyyyMmMatch) {
    const year = Number(yyyyMmMatch[1]);
    const month = Number(yyyyMmMatch[2]) - 1;
    if (month >= 0 && month <= 11) {
      return new Date(year, month, 1).getTime();
    }
  }

  const parsedDate = new Date(`01 ${rawValue}`);
  if (!Number.isNaN(parsedDate.getTime())) {
    return new Date(
      parsedDate.getFullYear(),
      parsedDate.getMonth(),
      1,
    ).getTime();
  }

  return null;
};

const compareBankStatementsByMonth = (left, right) => {
  const leftTimestamp = getStatementMonthTimestamp(left);
  const rightTimestamp = getStatementMonthTimestamp(right);

  if (leftTimestamp !== null && rightTimestamp !== null) {
    return leftTimestamp - rightTimestamp;
  }

  if (leftTimestamp !== null) return -1;
  if (rightTimestamp !== null) return 1;

  return normalizeStatementGroupValue(left?.statement_month_year, "").localeCompare(
    normalizeStatementGroupValue(right?.statement_month_year, ""),
  );
};

const ProfileViewer = ({
  keyman,
  isMobile,
  viewingUser,
  setViewingUser,
  singpassData,
  myinfoData,
  liveUserData,
  setLiveUserData,
  otherAuthoriserDetails,
  availableTab,
  setViewingTab,
  viewingTab,
  badgeVerified,
  allCBSData,
  combinedSingpassData,
  single,
  backupContact,
  notes,
  platform_notes,
  loan_remark,
  loanDocuments,
  applicationComments = [],
  hideContactInfo = false,
  showConciergeNotice = false,
  personalOnly = false,
  propertyApplicationId = null,
  propertyMyinfoSupportMode = false,
  bankAnalysisContext,
  mlcbAnalysisContext,
  sccbReportData,
  sccbReportType = "personal",
  sccbExcludeColumns = [],
}) => {
  const propertyProfileId = propertyApplicationId || (bankAnalysisContext?.loanType === "property" ? bankAnalysisContext.loanId : null);
  const propertyProfiles = usePropertyMyinfoProfiles(propertyProfileId, propertyMyinfoSupportMode);
  const [propertyPerson, setPropertyPerson] = useState({ applicationId: null, id: "keyman" });
  const propertyPersonId = propertyPerson.applicationId === propertyProfileId ? propertyPerson.id : "keyman";
  const selectedPropertyPerson = propertyProfiles.co_owners.find(person => person.id === propertyPersonId) || propertyProfiles.keyman;
  const viewingPropertyCoOwner = selectedPropertyPerson?.role === "Co-owner";
  const startSeachResults = async (toSearch) => {
    console.groupCollapsed("[ProfileViewer][SmartValuation] lookup start");
    console.log("[ProfileViewer][SmartValuation] raw property item", toSearch);
    try {
      let item2 = {
        propertyTypeCode: "land",
        postalCode: toSearch.address.postal.value,
        addressUnit: ``,
        addressNumber: "",
        addressStreet: "",
        valuationType: "sale",
        projectName: "",
      };
      console.log("[ProfileViewer][SmartValuation] land payload", item2);

      const response2 = await fetch(
        `https://www.smart-lend.com/api/property/getPropertyValuation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(item2),
        },
      );
      console.log("[ProfileViewer][SmartValuation] land response", {
        ok: response2.ok,
        status: response2.status,
        statusText: response2.statusText,
      });
      let item3 = {
        propertyTypeCode: "condo",
        postalCode: toSearch.address.postal.value,
        addressUnit: ``,
        addressNumber: "",
        addressStreet: "",
        valuationType: "sale",
        projectName: "",
      };
      console.log("[ProfileViewer][SmartValuation] condo payload", item3);

      const response3 = await fetch(
        `https://www.smart-lend.com/api/property/getPropertyValuation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(item3),
        },
      );
      console.log("[ProfileViewer][SmartValuation] condo response", {
        ok: response3.ok,
        status: response3.status,
        statusText: response3.statusText,
      });

      let item4 = {
        propertyTypeCode: "hdb",
        postalCode: toSearch.address.postal.value,
        addressUnit: ``,
        addressNumber: "",
        addressStreet: "",
        valuationType: "sale",
        projectName: "",
      };
      console.log("[ProfileViewer][SmartValuation] hdb payload", item4);

      const response4 = await fetch(
        `https://www.smart-lend.com/api/property/getPropertyValuation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(item4),
        },
      );
      console.log("[ProfileViewer][SmartValuation] hdb response", {
        ok: response4.ok,
        status: response4.status,
        statusText: response4.statusText,
      });

      const json2 = await response2.json();
      const json3 = await response3.json();
      const json4 = await response4.json();
      console.log("[ProfileViewer][SmartValuation] response json", {
        land: json2,
        condo: json3,
        hdb: json4,
      });

      // Store the result in the correct index
      const updatingpossibleResults = [
        ...json2.data,
        ...json3.data,
        ...json4.data,
      ];

      const floorUnit = `${toSearch.address.floor.value}-${toSearch.address.unit.value}`;
      console.log("[ProfileViewer][SmartValuation] candidates", {
        floorUnit,
        count: updatingpossibleResults.length,
        candidates: updatingpossibleResults,
      });
      if (!updatingpossibleResults || updatingpossibleResults.length === 0) {
        console.log("[ProfileViewer][SmartValuation] returning 0: no candidates");
        return 0;
      } else if (updatingpossibleResults.length === 1) {
        const result = {
          value: updatingpossibleResults?.[0]?.saleValuation?.toLocaleString(
            "en-US",
            {
              style: "currency",
              currency: "SGD",
            },
          ),
          type: updatingpossibleResults?.[0]?.propertyTypeCode,
        };
        console.log("[ProfileViewer][SmartValuation] returning single result", result);
        return result;
      } else {
        const matchingResults = updatingpossibleResults.filter(
          (result) => result.addressUnit === floorUnit,
        );
        console.log("[ProfileViewer][SmartValuation] unit match results", {
          floorUnit,
          count: matchingResults.length,
          matchingResults,
        });

        if (matchingResults.length > 1) {
          console.log(
            "[ProfileViewer][SmartValuation] returning 0: multiple matching units",
          );
          return 0;
        } else if (matchingResults.length === 1) {
          const result = {
            value: matchingResults?.[0]?.saleValuation?.toLocaleString(
              "en-US",
              {
                style: "currency",
                currency: "SGD",
              },
            ),
            type: matchingResults?.[0]?.propertyTypeCode,
          };
          console.log("[ProfileViewer][SmartValuation] returning matched result", result);
          return result;
        } else {
          console.log("[ProfileViewer][SmartValuation] returning 0: no unit match");
          return 0;
        }
      }
    } catch (error) {
      console.error("[ProfileViewer][SmartValuation] lookup failed", error);
    } finally {
      console.groupEnd();
    }
  };

  const [searchResults, setSearchResults] = useState({});
  const [loading, setLoading] = useState(false);
  const [bankAnalysisState, setBankAnalysisState] = useState({
    loading: false,
    statements: [],
    pendingCount: 0,
    error: null,
  });
  const [mlcbAnalysisState, setMlcbAnalysisState] = useState({
    loading: false,
    entries: [],
    error: null,
  });

  const analysisTabIndex = availableTab?.findIndex(
    (tab) => tab.name === "Customer Document Analysis",
  );
  const borrowerReportTabIndex = availableTab?.findIndex(
    (tab) => tab.name === "Borrower Report",
  );
  const mlcbAnalysisTabIndex = availableTab?.findIndex(
    (tab) => tab.name === "MLCB Analysis",
  );
  const sccbReportTabIndex = availableTab?.findIndex(
    (tab) => tab.name === "SCCB Report",
  );

  const sccbBrand = useMemo(
    () => ({
      logoDataUrl: logo,
      titleLeft:
        sccbReportType === "personal"
          ? "SMTV ENHANCED COMMERCIAL ENQUIRY REPORT"
          : "SMTV BIZ CHECK PLUS",
      titleRight: "In collaboration with SCCB",
    }),
    [sccbReportType],
  );
  const payslipDocuments = useMemo(() => {
    if (!loanDocuments) return [];
    const raw = loanDocuments?.payslip_documents;
    if (!raw) return [];
    if (typeof raw === "string") {
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }
    return Array.isArray(raw) ? raw : [];
  }, [loanDocuments]);

  const loanMeta = useMemo(() => {
    if (!loanDocuments?.meta) return {};
    if (typeof loanDocuments.meta === "string") {
      try {
        const parsed = JSON.parse(loanDocuments.meta);
        return parsed && typeof parsed === "object" ? parsed : {};
      } catch (error) {
        return {};
      }
    }
    return typeof loanDocuments.meta === "object" ? loanDocuments.meta : {};
  }, [loanDocuments]);

  const extractNoaIncome = (metadata) => {
    let normalizedMetadata = metadata;
    if (typeof normalizedMetadata === "string") {
      try {
        normalizedMetadata = JSON.parse(normalizedMetadata);
      } catch (error) {
        return null;
      }
    }

    if (!normalizedMetadata || typeof normalizedMetadata !== "object") {
      return null;
    }

    const report =
      normalizedMetadata.latest_report ||
      normalizedMetadata.latestReport ||
      normalizedMetadata.report ||
      normalizedMetadata;
    const preferredKeys = [
      "declared_income",
      "declaredIncome",
      "noa_declared_income",
      "noaDeclaredIncome",
      "annual_income",
      "annualIncome",
      "total_income",
      "totalIncome",
      "income_total",
      "incomeTotal",
      "assessable_income",
      "assessableIncome",
      "income",
    ];

    for (const key of preferredKeys) {
      const rawValue = report?.[key]?.value ?? report?.[key];
      if (rawValue !== undefined && rawValue !== null && rawValue !== "") {
        return rawValue;
      }
    }

    return null;
  };

  const sisterCompanyIncome = useMemo(() => {
    const noaMetadata =
      loanMeta?.noa_metadata ||
      loanMeta?.noaMetadata ||
      loanDocuments?.noa_metadata ||
      loanDocuments?.noaMetadata;
    const parsedNoaMetadata =
      typeof noaMetadata === "string"
        ? (() => {
            try {
              return JSON.parse(noaMetadata);
            } catch (error) {
              return null;
            }
          })()
        : noaMetadata;
    const hasNoaMetadata =
      parsedNoaMetadata &&
      typeof parsedNoaMetadata === "object" &&
      Object.keys(parsedNoaMetadata).length > 0;
    const declaredIncome =
      loanMeta?.declared_income ??
      loanMeta?.declaredIncome ??
      loanDocuments?.declared_income ??
      loanDocuments?.declaredIncome ??
      null;
    const noaIncome = hasNoaMetadata ? extractNoaIncome(parsedNoaMetadata) : null;
    const value = hasNoaMetadata ? noaIncome ?? declaredIncome : declaredIncome;
    const label =
      hasNoaMetadata && noaIncome !== undefined && noaIncome !== null && noaIncome !== ""
        ? "NOA Declared Income"
        : "Declared Income";

    if (value === undefined || value === null || value === "") {
      return null;
    }

    return {
      label,
      value,
    };
  }, [loanDocuments, loanMeta]);

  const getTabIcon = (tabName) => {
    const iconProps = { fontSize: "small" };
    switch (tabName) {
      case "Borrower Information":
        return <PersonOutlineIcon {...iconProps} />;
      case "Borrower Report":
        return <AssessmentOutlinedIcon {...iconProps} />;
      case "Customer Document Analysis":
        return <FactCheckOutlinedIcon {...iconProps} />;
      case "Company Information":
        return <BadgeOutlinedIcon {...iconProps} />;
      case "Personal Information":
        return <PersonOutlineIcon {...iconProps} />;
      case "Financial Information":
        return <AccountBalanceOutlinedIcon {...iconProps} />;
      case "Documents":
        return <DescriptionOutlinedIcon {...iconProps} />;
      case "Activity Log":
        return <HistoryEduOutlinedIcon {...iconProps} />;
      default:
        return <DescriptionOutlinedIcon {...iconProps} />;
    }
  };

  const getShareholderAddress = (data) => {
    console.log(data, combinedSingpassData);
    const allSingpassData = combinedSingpassData;
    const returnsingpass = allSingpassData.filter(
      (dat) => getPersonData(dat)?.name?.value === data,
    );
    console.log(returnsingpass || []);
    return returnsingpass || [];
  };

  useEffect(() => {
    setLoading(true);
    const processResults = async () => {
      console.groupCollapsed("[ProfileViewer][SmartValuation] process combinedSingpassData");
      console.log("[ProfileViewer][SmartValuation] combinedSingpassData", {
        count: combinedSingpassData?.length,
        combinedSingpassData,
      });

      try {
        const singpassRecords = Array.isArray(combinedSingpassData)
          ? combinedSingpassData
          : [];

        if (!singpassRecords.length) {
          console.log(
            "[ProfileViewer][SmartValuation] stopped: no combinedSingpassData",
          );
          setSearchResults({});
          return;
        }

        const groupedResults = {};

        for (const [userIndex, user] of singpassRecords.entries()) {
          if (!getPersonData(user)) {
            console.warn(
              "[ProfileViewer][SmartValuation] skipping invalid Singpass record",
              {
                userIndex,
                user,
              },
            );
            continue;
          }

          const name = getPersonData(user)?.name?.value || "Unknown";
          console.log("[ProfileViewer][SmartValuation] processing person", {
            name,
            hdbCount: getPersonData(user)?.hdbownership?.length || 0,
            cpfWithdrawalCount:
              getPersonData(user)?.cpfhousingwithdrawal?.withdrawaldetails?.length || 0,
          });

          // Ensure the user entry exists in groupedResults
          if (!groupedResults[name]) {
            groupedResults[name] = {
              hdb_data: [],
              cpf_data: [],
            };
          }

          // Process HDB ownership data
          for (const hdb of getPersonData(user)?.hdbownership || []) {
            const result = await startSeachResults(hdb);
            console.log("[ProfileViewer][SmartValuation] HDB lookup result", {
              name,
              index: groupedResults[name].hdb_data.length,
              result,
            });
            groupedResults[name].hdb_data.push(result);
          }

          // Process CPF withdrawal data
          for (const cpf of getPersonData(user)?.cpfhousingwithdrawal
            ?.withdrawaldetails || []) {
            const result = await startSeachResults(cpf);
            console.log("[ProfileViewer][SmartValuation] CPF lookup result", {
              name,
              index: groupedResults[name].cpf_data.length,
              result,
            });
            groupedResults[name].cpf_data.push(result);
          }
        }

        console.log("[ProfileViewer][SmartValuation] grouped searchResults", groupedResults);
        setSearchResults(groupedResults);
      } catch (error) {
        console.error("[ProfileViewer][SmartValuation] process failed", error);
      } finally {
        setLoading(false);
        console.groupEnd();
      }
    };

    processResults();
  }, [combinedSingpassData]);

  useEffect(() => {
    const shouldLoadAnalysis =
      viewingTab === analysisTabIndex || viewingTab === borrowerReportTabIndex;
    if (
      analysisTabIndex === -1 ||
      borrowerReportTabIndex === -1 ||
      !shouldLoadAnalysis ||
      !bankAnalysisContext?.enabled
    ) {
      return;
    }

    let isMounted = true;
    let pending = false;
    const controller = new AbortController();
    const isProperty = bankAnalysisContext.loanType === "property";
    setBankAnalysisState({
      loading: true,
      statements: [],
      pendingCount: 0,
      error: null,
    });
    const fetchAnalysis = async () => {
      if (pending || document.visibilityState === "hidden") return;
      pending = true;
      try {
        const response = await fetch(
          `https://www.smart-lend.com/api/bank-document-jobs/analysis?loan_id=${encodeURIComponent(
            bankAnalysisContext.loanId,
          )}&loan_type=${encodeURIComponent(bankAnalysisContext.loanType)}`,
          {
            method: "GET",
            signal: controller.signal,
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Cookies.get("token"),
            },
          },
        );
        const json = await response.json();
        if (!response.ok) {
          throw new Error(
            json?.message || "Unable to load bank statement analysis.",
          );
        }
        if (isMounted) {
          setBankAnalysisState({
            loading: false,
            statements: json?.statements || [],
            pendingCount: Number(json?.pending_count || 0),
            error: null,
          });
        }
      } catch (error) {
        if (controller.signal.aborted) return;
        console.error(error);
        if (isMounted) {
          setBankAnalysisState({
            loading: false,
            statements: [],
            pendingCount: 0,
            error: error?.message || "Unable to load bank statement analysis.",
          });
        }
      } finally {
        pending = false;
      }
    };

    fetchAnalysis();
    const timer = isProperty ? setInterval(fetchAnalysis, 15000) : null;
    if (isProperty) {
      window.addEventListener("focus", fetchAnalysis);
      document.addEventListener("visibilitychange", fetchAnalysis);
    }

    return () => {
      isMounted = false;
      controller.abort();
      if (timer) clearInterval(timer);
      if (isProperty) {
        window.removeEventListener("focus", fetchAnalysis);
        document.removeEventListener("visibilitychange", fetchAnalysis);
      }
    };
  }, [
    analysisTabIndex,
    borrowerReportTabIndex,
    viewingTab,
    bankAnalysisContext?.loanId,
    bankAnalysisContext?.loanType,
    bankAnalysisContext?.enabled,
  ]);

  useEffect(() => {
    const shouldLoadMlcb =
      viewingTab === mlcbAnalysisTabIndex ||
      viewingTab === borrowerReportTabIndex;
    if (
      mlcbAnalysisTabIndex === -1 ||
      borrowerReportTabIndex === -1 ||
      !shouldLoadMlcb ||
      !mlcbAnalysisContext?.enabled
    ) {
      return;
    }

    let isMounted = true;
    const fetchMlcbAnalysis = async () => {
      setMlcbAnalysisState({ loading: true, entries: [], error: null });
      try {
        const response = await fetch(
          `https://www.smart-lend.com/api/personalLoans/${encodeURIComponent(
            mlcbAnalysisContext.loanId,
          )}/mlcb-analysis`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + Cookies.get("token"),
            },
          },
        );
        const json = await response.json();
        if (!response.ok) {
          throw new Error(json?.message || "Unable to load MLCB analysis.");
        }
        if (isMounted) {
          setMlcbAnalysisState({
            loading: false,
            entries: json?.entries || [],
            error: null,
          });
        }
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setMlcbAnalysisState({
            loading: false,
            entries: [],
            error: error?.message || "Unable to load MLCB analysis.",
          });
        }
      }
    };

    fetchMlcbAnalysis();

    return () => {
      isMounted = false;
    };
  }, [
    mlcbAnalysisTabIndex,
    borrowerReportTabIndex,
    viewingTab,
    mlcbAnalysisContext?.enabled,
    mlcbAnalysisContext?.loanId,
  ]);

  const formatStatementAmount = (value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return numeric.toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
    });
  };

  const formatStatementDate = (value) => {
    if (!value) return "";
    try {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return format(date, "MMM dd, yyyy");
    } catch (error) {
      return value;
    }
  };

  const groupedBankAnalysisStatements = useMemo(() => {
    const groupedStatements = new Map();

    bankAnalysisState.statements.forEach((statement) => {
      const bank = normalizeStatementGroupValue(statement?.bank, "Bank Unknown");
      const accountNumber = normalizeStatementGroupValue(
        statement?.bank_account_number,
        "Account Unknown",
      );
      const groupKey = `${bank.toLowerCase()}::${accountNumber.toLowerCase()}`;

      if (!groupedStatements.has(groupKey)) {
        groupedStatements.set(groupKey, {
          groupKey,
          bank,
          accountNumber,
          statements: [],
        });
      }

      groupedStatements.get(groupKey).statements.push(statement);
    });

    return Array.from(groupedStatements.values())
      .map((group) => ({
        ...group,
        statements: [...group.statements].sort(compareBankStatementsByMonth),
      }))
      .sort((left, right) => {
        const bankCompare = left.bank.localeCompare(right.bank);
        if (bankCompare !== 0) return bankCompare;
        return left.accountNumber.localeCompare(right.accountNumber);
      });
  }, [bankAnalysisState.statements]);

  const formatMlcbAmount = (value) => {
    if (value === undefined || value === null || value === "") {
      return "-";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return numeric.toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
    });
  };

  const [backupContactDetails, setBackupContactDetails] = useState(null);
  const profileData = propertyProfileId
    ? getMyInfoData(selectedPropertyPerson?.myinfo_data) || (!viewingPropertyCoOwner ? getMyInfoData(myinfoData) || getMyInfoData(singpassData) : null)
    : personalOnly
    ? getMyInfoData(myinfoData) || getMyInfoData(singpassData)
    : getPersonData(liveUserData);
  const hasProfileViewerContent = Boolean(
    profileData || liveUserData || (personalOnly && loanDocuments),
  );
  const hiddenPersonalTabs = new Set([
    "Corporate Information",
    "NOA History",
    "Capitals",
    "Financials",
    "Shareholders",
  ]);

  const formatAddress = (address) => {
    if (!address) return "";
    return (
      (address?.unit?.value != null ? `Unit ${address.unit.value}, ` : "") +
      (address?.floor?.value != null ? `Floor ${address.floor.value}, ` : "") +
      (address?.block?.value != null ? `Block ${address.block.value}, ` : "") +
      (address?.street?.value != null ? `${address.street.value}, ` : "") +
      (address?.postal?.value != null ? `${address.postal.value}, ` : "") +
      (address?.country?.desc != null ? `${address.country.desc}.` : "")
    );
  };

  const formatMobileNumber = (data) => {
    if (personalOnly) {
      if (!data?.mobileno) return "";
      const parts = [
        data?.mobileno?.prefix?.value,
        data?.mobileno?.areacode?.value,
        data?.mobileno?.nbr?.value,
      ].filter(Boolean);
      return parts.join("");
    }
    return data?.mobileno?.nbr?.value || "";
  };

  const maskContactValue = (value) => {
    if (!hideContactInfo) {
      return value;
    }

    if (value === null || value === undefined || value === "") {
      return value;
    }

    return "Hidden";
  };

  const getDisplayEmail = (value) => maskContactValue(value);
  const getDisplayMobile = (value) => maskContactValue(value);

  const formatOwnerPrivate = (value) => {
    if (!personalOnly) return value;
    if (value === undefined || value === null) return "";
    return value ? "True" : "False";
  };

  const formatCurrency = (value) => {
    if (value === undefined || value === null || value === "") return "";
    return Number(value).toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const formatDateValue = (value) => {
    if (!value) return "";
    try {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return value;
      return format(date, "MMM dd, yyyy");
    } catch (error) {
      return value;
    }
  };

  const formatYearMonth = (value) => {
    if (!value) return "";
    const text = String(value);
    if (text.length === 6) {
      return `${text.slice(0, 4)}-${text.slice(4)}`;
    }
    return text;
  };

  const formatReportValue = (value) => {
    if (value === undefined || value === null || value === "") {
      return "N/A";
    }
    return value;
  };

  const formatReportCurrency = (value) => {
    if (value === undefined || value === null || value === "") {
      return "N/A";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return numeric.toLocaleString("en-US", {
      style: "currency",
      currency: "SGD",
    });
  };

  const formatReportPercent = (value) => {
    if (value === undefined || value === null || value === "") {
      return "N/A";
    }
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return value;
    return `${numeric}%`;
  };

  const parseReportData = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  };

  const toArray = (value) => (Array.isArray(value) ? value : []);

  const formatYesNo = (value) => {
    if (value === undefined || value === null || value === "") {
      return "N/A";
    }
    return value ? "Yes" : "No";
  };

  const hdbOwnershipEntries = toArray(profileData?.hdbownership);
  const vehicleEntries = toArray(profileData?.vehicles);
  const cpfHousingWithdrawalEntries = toArray(
    profileData?.cpfhousingwithdrawal?.withdrawaldetails,
  );
  const cpfAccountEntries = Object.entries(profileData?.cpfbalances || {});
  const cpfContributionEntries = toArray(
    profileData?.cpfcontributions?.history,
  );
  const noaHistoryEntries = toArray(profileData?.noahistory?.noas);

  const personalReportEntries = [
    { label: "NRIC", value: formatReportValue(profileData?.uinfin?.value) },
    { label: "Full Name", value: formatReportValue(profileData?.name?.value) },
    { label: "Sex", value: formatReportValue(profileData?.sex?.desc) },
    { label: "Race", value: formatReportValue(profileData?.race?.desc) },
    {
      label: "Nationality",
      value: formatReportValue(profileData?.nationality?.desc),
    },
    {
      label: "Date of Birth",
      value: formatReportValue(formatDateValue(profileData?.dob?.value)),
    },
    {
      label: "Country of Birth",
      value: formatReportValue(profileData?.birthcountry?.desc),
    },
    {
      label: "Residential Status",
      value: formatReportValue(profileData?.residentialstatus?.desc),
    },
    {
      label: "Pass Type",
      value: formatReportValue(profileData?.passtype?.desc),
    },
    {
      label: "Pass Status",
      value: formatReportValue(
        profileData?.passstatus?.desc || profileData?.passstatus?.value,
      ),
    },
    {
      label: "Pass Expiry Date",
      value: formatReportValue(
        formatDateValue(profileData?.passexpirydate?.value),
      ),
    },
    {
      label: "Ownership of Private Property Status",
      value: formatYesNo(profileData?.ownerprivate?.value),
    },
    {
      label: "Marital Status",
      value: formatReportValue(profileData?.marital?.desc),
    },
    {
      label: "Email",
      value: formatReportValue(getDisplayEmail(profileData?.email?.value)),
    },
    {
      label: "Mobile Number",
      value: formatReportValue(
        getDisplayMobile(formatMobileNumber(profileData)),
      ),
    },
    {
      label: "Registered Address",
      value: formatReportValue(formatAddress(profileData?.regadd)),
    },
    {
      label: "Employment",
      value: formatReportValue(profileData?.employment?.value),
    },
    {
      label: "Occupation",
      value: formatReportValue(profileData?.occupation?.value),
    },
    {
      label: "Employment Sector",
      value: formatReportValue(profileData?.employmentsector?.value),
    },
    ...(sisterCompanyIncome
      ? [
          {
            label: sisterCompanyIncome.label,
            value: formatReportCurrency(sisterCompanyIncome.value),
          },
        ]
      : []),
  ];

  const personalMyInfoSections = [
    {
      title: "Housing & HDB",
      rows: [
        {
          label: "Housing Type",
          value: formatReportValue(profileData?.housingtype?.desc),
        },
        {
          label: "HDB Type",
          value: formatReportValue(profileData?.hdbtype?.desc),
        },
        ...hdbOwnershipEntries.flatMap((hdb, index) => [
          {
            label: `HDB Ownership ${index + 1} - Address`,
            value: formatReportValue(formatAddress(hdb?.address)),
          },
          {
            label: `HDB Ownership ${index + 1} - Outstanding Loan`,
            value: formatReportCurrency(hdb?.loan?.value),
          },
          {
            label: `HDB Ownership ${index + 1} - Type`,
            value: formatReportValue(hdb?.type?.desc),
          },
          {
            label: `HDB Ownership ${index + 1} - Monthly Installment`,
            value: formatReportCurrency(hdb?.monthlyinstallment?.value),
          },
        ]),
      ],
    },
    {
      title: "Vehicle",
      rows: vehicleEntries.length
        ? vehicleEntries.flatMap((vehicle, index) => [
            {
              label: `Vehicle ${index + 1} - Make`,
              value: formatReportValue(vehicle?.make?.value),
            },
            {
              label: `Vehicle ${index + 1} - Model`,
              value: formatReportValue(vehicle?.model?.value),
            },
          ])
        : [{ label: "Vehicle", value: "No vehicle records available." }],
    },
    {
      title: "CPF Account Details",
      rows: cpfAccountEntries.length
        ? cpfAccountEntries.map(([accountKey, accountData]) => ({
            label: `${String(accountKey).toUpperCase()} Balance`,
            value: formatReportCurrency(accountData?.value),
          }))
        : [
            {
              label: "CPF Account Details",
              value: "No CPF account details available.",
            },
          ],
    },
    {
      title: "CPF Contributions",
      rows: cpfContributionEntries.length
        ? cpfContributionEntries.flatMap((entry, index) => [
            {
              label: `Contribution ${index + 1} - Employer`,
              value: formatReportValue(entry?.employer?.value),
            },
            {
              label: `Contribution ${index + 1} - Paid On`,
              value: formatReportValue(formatDateValue(entry?.date?.value)),
            },
            {
              label: `Contribution ${index + 1} - Month`,
              value: formatReportValue(formatYearMonth(entry?.month?.value)),
            },
            {
              label: `Contribution ${index + 1} - Amount`,
              value: formatReportCurrency(entry?.amount?.value),
            },
          ])
        : [
            {
              label: "CPF Contributions",
              value: "No CPF contribution history available.",
            },
          ],
    },
    {
      title: "NOA History",
      rows: noaHistoryEntries.length
        ? noaHistoryEntries.flatMap((entry, index) => [
            {
              label: `NOA ${index + 1} - Year of Assessment`,
              value: formatReportValue(entry?.yearofassessment?.value),
            },
            {
              label: `NOA ${index + 1} - Employment`,
              value: formatReportCurrency(entry?.employment?.value),
            },
            {
              label: `NOA ${index + 1} - Trade`,
              value: formatReportCurrency(entry?.trade?.value),
            },
            {
              label: `NOA ${index + 1} - Interest`,
              value: formatReportCurrency(entry?.interest?.value),
            },
            {
              label: `NOA ${index + 1} - Rent`,
              value: formatReportCurrency(entry?.rent?.value),
            },
            {
              label: `NOA ${index + 1} - Total`,
              value: formatReportCurrency(entry?.amount?.value),
            },
          ])
        : [{ label: "NOA History", value: "No NOA history available." }],
    },
  ];

  const cpfHousingWithdrawalRows = cpfHousingWithdrawalEntries.length
    ? cpfHousingWithdrawalEntries.flatMap((entry, index) => [
        {
          label: `Property ${index + 1} - Address`,
          value: formatReportValue(formatAddress(entry?.address)),
        },
        {
          label: `Property ${index + 1} - Monthly Installment`,
          value: formatReportCurrency(entry?.monthlyinstallment?.value),
        },
        {
          label: `Property ${index + 1} - Remaining Lease`,
          value: formatReportValue(entry?.remaininglease?.value),
        },
        {
          label: `Property ${index + 1} - Total CPF Allowed`,
          value: formatReportCurrency(entry?.totalcpfallowedforproperty?.value),
        },
      ])
    : [
        {
          label: "CPF Usage",
          value: "No CPF housing withdrawal details available.",
        },
      ];

  const reportTheme = {
    headerBlue: "#224587",
    borderBlue: "#b7c6dc",
    rowOdd: "#f3f6fb",
    rowEven: "#ffffff",
    labelColor: "#3f4b61",
  };
  const reportTitleFontSize = 11;
  const reportBodyFontSize = 8;

  const renderTwoColumnRows = (rows) =>
    rows.map((row, index) => (
      <View
        key={`${row.label}-${index}`}
        style={{
          flexDirection: "row",
          borderBottomWidth: 1,
          borderBottomColor: reportTheme.borderBlue,
          backgroundColor:
            index % 2 === 0 ? reportTheme.rowEven : reportTheme.rowOdd,
        }}
      >
        <View
          style={{
            width: "40%",
            paddingVertical: 6,
            paddingHorizontal: 8,
            borderRightWidth: 1,
            borderRightColor: reportTheme.borderBlue,
          }}
        >
          <Text
            style={{
              fontSize: reportBodyFontSize,
              fontFamily: "Poppins",
              color: reportTheme.labelColor,
              fontWeight: 700,
            }}
          >
            {row.label}
          </Text>
        </View>
        <View
          style={{ width: "60%", paddingVertical: 6, paddingHorizontal: 8 }}
        >
          <Text
            style={{
              fontSize: reportBodyFontSize,
              fontFamily: "Poppins",
            }}
          >
            {row.value}
          </Text>
        </View>
      </View>
    ));

  const renderPersonalMyInfoSectionsPdf = () => (
    <>
      {personalMyInfoSections.map((section) => (
        <View key={section.title} style={{ marginBottom: 8 }}>
          <View
            style={{
              backgroundColor: reportTheme.headerBlue,
              alignItems: "center",
              padding: 8,
              borderTopLeftRadius: 7,
              borderTopRightRadius: 7,
            }}
          >
            <Text
              style={{
                fontSize: reportTitleFontSize,
                fontFamily: "Poppins",
                fontWeight: 700,
                color: "#ffffff",
              }}
            >
              {section.title}
            </Text>
          </View>
          <View
            style={{
              borderColor: reportTheme.borderBlue,
              borderWidth: 1,
            }}
          >
            {renderTwoColumnRows(section.rows)}
          </View>
        </View>
      ))}
      <View style={{ marginBottom: 8 }}>
        <View
          style={{
            backgroundColor: reportTheme.headerBlue,
            alignItems: "center",
            padding: 8,
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
          }}
        >
          <Text
            style={{
              fontSize: reportTitleFontSize,
              fontFamily: "Poppins",
              fontWeight: 700,
              color: "#ffffff",
            }}
          >
            CPF Usage (Housing Withdrawal)
          </Text>
        </View>
        <View
          style={{
            borderColor: reportTheme.borderBlue,
            borderWidth: 1,
          }}
        >
          {renderTwoColumnRows(cpfHousingWithdrawalRows)}
        </View>
      </View>
    </>
  );

  const personalCbsData = (() => {
    if (viewingPropertyCoOwner) return null;
    const isPersonalLoanReport =
      personalOnly || bankAnalysisContext?.loanType === "personal";
    if (!isPersonalLoanReport) return null;
    const backupMatch =
      backupContactDetails?.user_id && Array.isArray(allCBSData)
        ? allCBSData.find(
            (entry) => entry?.user_id === backupContactDetails?.user_id,
          )?.cbs_data
        : null;
    const directMatch = Array.isArray(allCBSData)
      ? allCBSData?.[0]?.cbs_data
      : null;
    return (
      parseReportData(directMatch) ||
      parseReportData(backupMatch) ||
      parseReportData(backupContactDetails?.credit_report_data)
    );
  })();

  const renderPersonalCbsReport = () => {
    if (!personalCbsData) {
      return (
        <View
          style={{
            padding: 8,
            borderColor: reportTheme.borderBlue,
            borderWidth: 1,
          }}
        >
          <Text
            style={{
              fontSize: reportBodyFontSize,
              fontFamily: "Poppins",
            }}
          >
            CBS report not available for this borrower.
          </Text>
        </View>
      );
    }

    const noteworthyLoans = personalCbsData?.NoteworthyOngoingLoans || [];
    const supplementary =
      personalCbsData?.CBSImpLoanSupplementaryInstallment || [];
    const chartData = personalCbsData?.Last6MonthsGraphChartData || [];
    const chartMaxRaw = personalCbsData?.Last6MonthsGraphChartMaxData;
    const chartMaxValue = Number(chartMaxRaw);
    const chartMax =
      Number.isNaN(chartMaxValue) || chartMaxValue === 0 ? 1 : chartMaxValue;

    const parseInstallment = (value) => {
      if (!value) return null;
      const parts = value.split("   ");
      if (parts.length < 4) return null;
      const first = Number(parts[parts.length - 4]?.replace(/,/g, ""));
      const second = Number(parts[parts.length - 3]?.replace(/,/g, ""));
      if (Number.isNaN(first) || Number.isNaN(second)) return null;
      return first + second;
    };

    return (
      <>
        <View
          style={{
            backgroundColor: reportTheme.headerBlue,
            alignItems: "center",
            padding: 8,
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
          }}
        >
          <Text
            style={{
              fontSize: reportTitleFontSize,
              fontFamily: "Poppins",
              fontWeight: 700,
              color: "#ffffff",
            }}
          >
            Credit Bureau Report Analysis
          </Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            paddingVertical: 2,
            borderColor: reportTheme.borderBlue,
            borderLeftWidth: 1,
            borderRightWidth: 1,
          }}
        >
          <View style={{ width: "50%" }}>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Secured Credit Limit:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportCurrency(personalCbsData?.SecuredCreditLimit)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Credit Score:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportValue(personalCbsData?.CreditScore)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Probability of Default:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportValue(personalCbsData?.ProbabilityofDefault)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Unsecured Credit Utilized:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportCurrency(personalCbsData?.UnsecuredCreditUtilized)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Unsecured Credit Utilization in percentage:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportPercent(
                  personalCbsData?.UnsecuredCreditUtilizationinpercentage,
                )}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Default Record:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {personalCbsData?.defaults ? "True" : "N/A"}
              </Text>
            </View>
          </View>
          <View style={{ width: "50%" }}>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Unsecured Credit Limit:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportCurrency(personalCbsData?.UnsecuredCreditLimit)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Risk Grade:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportValue(personalCbsData?.RiskGrade)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Secured Credit Utilized:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportCurrency(personalCbsData?.SecuredCreditUtilized)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Secured Credit Utilization in percentage:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportPercent(
                  personalCbsData?.SecuredCreditUtilizationinpercentage,
                )}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Monthly Commitment/Installment Secured:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {formatReportCurrency(personalCbsData?.MonthlyCommitment)}
              </Text>
            </View>
            <View style={{ flexDirection: "row", gap: 10 }}>
              <Text
                style={{
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                }}
              >
                Bankcruptcy Proceedings:
              </Text>
              <Text style={{ fontSize: reportBodyFontSize }}>
                {personalCbsData?.bankcruptcyProceedings ? "True" : "N/A"}
              </Text>
            </View>
          </View>
        </View>
        {personalCbsData?.defaults ? (
          <View
            style={{
              borderLeftWidth: 1,
              borderRightWidth: 1,
              borderColor: reportTheme.borderBlue,
              paddingHorizontal: 8,
            }}
          >
            <View>
              <Text
                style={{ fontSize: reportBodyFontSize, fontFamily: "Poppins" }}
              >
                Disclaimer
              </Text>
            </View>
            <View>
              <Text
                style={{ fontSize: reportBodyFontSize, fontFamily: "Poppins" }}
              >
                Take note that due to the user having default or bankcruptcy
                proceedings the values above might not be reliable due to the
                change in circumstances.
              </Text>
            </View>
          </View>
        ) : null}
        <View
          style={{
            padding: 0,
            borderColor: reportTheme.borderBlue,
            borderLeftWidth: 1,
            borderRightWidth: 1,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              backgroundColor: reportTheme.headerBlue,
              padding: 6,
              gap: 10,
            }}
          >
            <View
              style={{
                width: "30%",
                fontSize: reportBodyFontSize,
                fontFamily: "Poppins",
              }}
            >
              <Text style={{ color: "#ffffff", fontWeight: 700 }}>
                Loan / Product Type
              </Text>
            </View>
            <View
              style={{
                width: "30%",
                fontSize: reportBodyFontSize,
                fontFamily: "Poppins",
              }}
            >
              <Text style={{ color: "#ffffff", fontWeight: 700 }}>
                Grantor / Bank
              </Text>
            </View>
            <View
              style={{
                width: "20%",
                fontSize: reportBodyFontSize,
                fontFamily: "Poppins",
              }}
            >
              <Text style={{ color: "#ffffff", fontWeight: 700 }}>
                Outstanding Balance
              </Text>
            </View>
            <View
              style={{
                width: "20%",
                fontSize: reportBodyFontSize,
                fontFamily: "Poppins",
              }}
            >
              <Text style={{ color: "#ffffff", fontWeight: 700 }}>
                Monthly Installment
              </Text>
            </View>
          </View>
          {noteworthyLoans.length ? (
            noteworthyLoans.map((imp, index10) => (
              <View
                key={index10}
                style={{
                  flexDirection: "row",
                  width: "100%",
                  backgroundColor:
                    index10 % 2 ? reportTheme.rowOdd : reportTheme.rowEven,
                  padding: 6,
                  gap: 10,
                  borderTopWidth: 1,
                  borderTopColor: reportTheme.borderBlue,
                }}
              >
                <View
                  style={{
                    width: "30%",
                    fontSize: reportBodyFontSize,
                    fontFamily: "Poppins",
                  }}
                >
                  <Text>
                    {imp.includes("private residential purchase", "")
                      ? "Private Residential Purchase"
                      : imp.includes("motor vehicle loan", "")
                        ? "Motor Vehicle Loan"
                        : imp.includes("hdb loan", "")
                          ? "HDB Loan"
                          : ""}
                  </Text>
                </View>
                <View
                  style={{
                    width: "30%",
                    fontSize: reportBodyFontSize,
                    fontFamily: "Poppins",
                  }}
                >
                  <Text>
                    {imp
                      .replace("private residential purchase", "")
                      .replace("motor vehicle loan", "")
                      .replace("hdb loan", "")
                      .trim()
                      .split(" ")[0]
                      ?.toUpperCase()}
                  </Text>
                </View>
                <View
                  style={{
                    width: "20%",
                    fontSize: reportBodyFontSize,
                    fontFamily: "Poppins",
                  }}
                >
                  <Text>
                    {parseFloat(
                      imp
                        .split("   ")
                        [imp.split("   ").length - 4]?.replace(/,/g, ""),
                    ).toLocaleString("en-US", {
                      style: "currency",
                      currency: "SGD",
                    })}
                  </Text>
                </View>
                <View
                  style={{
                    width: "20%",
                    fontSize: reportBodyFontSize,
                    fontFamily: "Poppins",
                  }}
                >
                  <Text>
                    {parseInstallment(supplementary[index10])?.toLocaleString(
                      "en-US",
                      {
                        style: "currency",
                        currency: "SGD",
                      },
                    )}
                  </Text>
                </View>
              </View>
            ))
          ) : (
            <View
              style={{
                flexDirection: "row",
                width: "100%",
                backgroundColor: reportTheme.rowEven,
                padding: 6,
                gap: 10,
                borderTopWidth: 1,
                borderTopColor: reportTheme.borderBlue,
              }}
            >
              <View
                style={{
                  width: "30%",
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                }}
              >
                <Text>-</Text>
              </View>
              <View
                style={{
                  width: "30%",
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                }}
              >
                <Text>-</Text>
              </View>
              <View
                style={{
                  width: "20%",
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                }}
              >
                <Text>-</Text>
              </View>
              <View
                style={{
                  width: "20%",
                  fontSize: reportBodyFontSize,
                  fontFamily: "Poppins",
                }}
              >
                <Text>-</Text>
              </View>
            </View>
          )}
        </View>
        <View
          style={{
            backgroundColor: reportTheme.headerBlue,
            alignItems: "center",
            padding: 8,
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
          }}
        >
          <Text
            style={{
              fontSize: reportTitleFontSize,
              fontFamily: "Poppins",
              fontWeight: 700,
              color: "#ffffff",
            }}
          >
            Last 6 Months (Unsecured) Credit Utilization Graph
          </Text>
        </View>
        <View
          style={{
            padding: 8,
            borderColor: reportTheme.borderBlue,
            borderLeftWidth: 1,
            borderRightWidth: 1,
            borderBottomWidth: 1,
          }}
        >
          <View style={{ width: "100%", fontSize: reportBodyFontSize }}>
            <View style={{ flexDirection: "row" }}>
              <View
                style={{
                  width: "5%",
                  position: "relative",
                }}
              >
                <View style={{ height: "15px" }}>
                  <Text
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  >
                    {chartMaxRaw ? formatReportCurrency(chartMaxRaw) : "N/A"}
                  </Text>
                </View>
                <View style={{ height: "220px" }}></View>
              </View>
              <View style={{ width: "95%" }}>
                <View
                  style={{
                    width: "100%",
                    flexDirection: "row",
                    marginTop: "25px",
                    borderBottom: "1px solid lightgrey",
                    height: "200px",
                    alignItems: "flex-end",
                  }}
                >
                  <View
                    style={{
                      height: "200px",
                      borderLeft: "1px solid lightgrey",
                    }}
                  />
                  {chartData.map((dat30, index30) => {
                    const rawValue = Number(
                      (dat30?.value || "0").toString().replace(/,/g, ""),
                    );
                    const heightValue =
                      Number.isNaN(rawValue) || chartMax === 0
                        ? 0
                        : (rawValue / chartMax) * 100;
                    return (
                      <View
                        key={index30}
                        style={{
                          marginLeft: "4%",
                          marginRight: "4%",
                          width: "8%",
                          borderTopLeftRadius: "4px",
                          borderTopRightRadius: "4px",
                          height: `${heightValue}%`,
                          backgroundColor: "rgba(217, 238, 255, 1)",
                        }}
                      ></View>
                    );
                  })}
                </View>
                <View
                  style={{
                    marginTop: "8px",
                    flexDirection: "row",
                    fontSize: reportBodyFontSize,
                  }}
                >
                  {chartData.length ? (
                    chartData.map((dat, index) => (
                      <View
                        key={index}
                        style={{
                          width: "16%",
                          textAlign: "center",
                        }}
                      >
                        <Text
                          style={{
                            fontWeight: 600,
                            fontSize: reportBodyFontSize,
                          }}
                        >
                          {dat?.date
                            ? dat.date.charAt(0).toUpperCase() +
                              dat.date.slice(1)
                            : "-"}
                        </Text>
                        <Text
                          style={{
                            fontWeight: 600,
                            fontSize: reportBodyFontSize,
                          }}
                        >
                          {dat?.value
                            ? formatReportCurrency(
                                dat.value.toString().replace(/,/g, ""),
                              )
                            : "-"}
                        </Text>
                      </View>
                    ))
                  ) : (
                    <View
                      style={{
                        width: "100%",
                        textAlign: "center",
                      }}
                    >
                      <Text
                        style={{
                          fontWeight: 600,
                          fontSize: reportBodyFontSize,
                        }}
                      >
                        -
                      </Text>
                    </View>
                  )}
                </View>
              </View>
            </View>
          </View>
        </View>
      </>
    );
  };

  const isPropertyLoanReport = bankAnalysisContext?.loanType === "property";
  const sccbBorrowerReportData = useMemo(() => {
    if (!isPropertyLoanReport || !sccbReportData) return null;
    return parseSccbReportData(sccbReportData);
  }, [isPropertyLoanReport, sccbReportData]);

  const renderSccbPaymentInformation = () => {
    if (!sccbBorrowerReportData) return null;
    const paymentGrade = sccbBorrowerReportData.PAYMENT_GRADE || {};
    const paymentRecord = `Score ${ensureSccbValue(
      paymentGrade.SCORE,
    )} | Current ${ensureSccbValue(paymentGrade.CURRENT)} | 30D ${ensureSccbValue(
      paymentGrade.DAYS_30,
    )} | 60D ${ensureSccbValue(paymentGrade.DAYS_60)} | 90D ${ensureSccbValue(
      paymentGrade.DAYS_90,
    )} | >90D ${ensureSccbValue(
      paymentGrade.MORE_THAN_90,
    )} | Record ${ensureSccbValue(paymentGrade.PAYMENT_RECORD)}`;

    return (
      <View style={{ marginTop: 10 }}>
        <View
          style={{
            backgroundColor: "#c7dcec",
            alignItems: "center",
            padding: 4,
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
          }}
        >
          <Text
            style={{
              fontSize: 8,
              fontFamily: "Poppins",
              fontWeight: 700,
            }}
          >
            Payment Information
          </Text>
        </View>
        <View
          style={{
            borderColor: "#c7dcec",
            borderLeftWidth: 2,
            borderRightWidth: 2,
            borderBottomWidth: 2,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              backgroundColor: "#2881c4",
            }}
          >
            {[
              "STATUS DATE",
              "PAYING RECORD",
              "CREDIT SCORE",
              "TOTAL CREDIT",
              "PAST DUE AMOUNT",
            ].map((label, index, arr) => (
              <Text
                key={label}
                style={{
                  flex: 1,
                  fontSize: 6,
                  color: "#ffffff",
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  padding: 4,
                  borderRightWidth: index === arr.length - 1 ? 0 : 1,
                  borderRightColor: "#c7dcec",
                }}
              >
                {label}
              </Text>
            ))}
          </View>
          <View style={{ flexDirection: "row" }}>
            {[
              ensureSccbValue(paymentGrade.STATUS_DATE),
              paymentRecord,
              ensureSccbValue(paymentGrade.CREDIT_SCORE),
              ensureSccbValue(paymentGrade.TOTAL_CREDIT),
              ensureSccbValue(paymentGrade.PAST_DUE_AMOUNT),
            ].map((value, index, arr) => (
              <Text
                key={`payment-cell-${index}`}
                style={{
                  flex: 1,
                  fontSize: 6,
                  fontFamily: "Poppins",
                  padding: 4,
                  borderRightWidth: index === arr.length - 1 ? 0 : 1,
                  borderRightColor: "#c7dcec",
                }}
              >
                {value}
              </Text>
            ))}
          </View>
        </View>
      </View>
    );
  };

  const renderSccbListSection = (title, listData) => {
    if (!sccbBorrowerReportData) return null;
    const rows = normalizeSccbList(listData);
    const columns = rows.length
      ? Array.from(
          rows.reduce((set, row) => {
            if (row && typeof row === "object") {
              Object.keys(row).forEach((key) => set.add(key));
            }
            return set;
          }, new Set()),
        )
      : [];

    return (
      <View style={{ marginTop: 10 }}>
        <View
          style={{
            backgroundColor: "#c7dcec",
            alignItems: "center",
            padding: 4,
            borderTopLeftRadius: 7,
            borderTopRightRadius: 7,
          }}
        >
          <Text
            style={{
              fontSize: 8,
              fontFamily: "Poppins",
              fontWeight: 700,
            }}
          >
            {title}
          </Text>
        </View>
        <View
          style={{
            borderColor: "#c7dcec",
            borderLeftWidth: 2,
            borderRightWidth: 2,
            borderBottomWidth: 2,
          }}
        >
          {rows.length && columns.length ? (
            <>
              <View
                style={{
                  flexDirection: "row",
                  backgroundColor: "#2881c4",
                }}
              >
                {columns.map((column, index) => (
                  <Text
                    key={`${title}-col-${column}-${index}`}
                    style={{
                      flex: 1,
                      fontSize: 6,
                      color: "#ffffff",
                      fontFamily: "Poppins",
                      fontWeight: 700,
                      padding: 4,
                      borderRightWidth: index === columns.length - 1 ? 0 : 1,
                      borderRightColor: "#c7dcec",
                    }}
                  >
                    {formatSccbColumnLabel(column)}
                  </Text>
                ))}
              </View>
              {rows.map((row, rowIndex) => (
                <View
                  key={`${title}-row-${rowIndex}`}
                  style={{ flexDirection: "row" }}
                >
                  {columns.map((column, index) => (
                    <Text
                      key={`${title}-cell-${rowIndex}-${column}-${index}`}
                      style={{
                        flex: 1,
                        fontSize: 6,
                        fontFamily: "Poppins",
                        padding: 4,
                        borderRightWidth: index === columns.length - 1 ? 0 : 1,
                        borderRightColor: "#c7dcec",
                      }}
                    >
                      {ensureSccbValue(row?.[column])}
                    </Text>
                  ))}
                </View>
              ))}
            </>
          ) : (
            <View style={{ padding: 6 }}>
              <Text style={{ fontSize: 6, fontFamily: "Poppins" }}>
                No records found.
              </Text>
            </View>
          )}
        </View>
      </View>
    );
  };

  const renderSccbBorrowerSections = () => {
    if (!sccbBorrowerReportData || !isPropertyLoanReport) return null;
    return (
      <>
        {renderSccbPaymentInformation()}
        {renderSccbListSection("LIST LIT", sccbBorrowerReportData.LIST_LIT)}
        {renderSccbListSection(
          "LIST BANKRUPTCY",
          sccbBorrowerReportData.LIST_BANKRUPTCY,
        )}
      </>
    );
  };

  const renderPdfHeader = (title) => (
    <View style={{ paddingVertical: 8 }}>
      <View
        style={{
          paddingHorizontal: 28,
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 6,
          paddingBottom: 6,
        }}
      >
        <Image source={logo} style={{ width: 72, objectFit: "contain" }} />
        <View>
          <Text
            style={{
              fontSize: 16,
              fontFamily: "Poppins",
              fontWeight: 700,
              color: reportTheme.headerBlue,
            }}
          >
            SmartLend Financial Pte. Ltd.
          </Text>
          <View
            style={{
              flexDirection: "row",
              gap: 4,
              justifyContent: "center",
              alignItems: "center",
              marginTop: -3,
            }}
          >
            <Text style={{ fontSize: 8, color: "#4a5568" }}>
              UEN: 202327568G
            </Text>
            <Text style={{ fontSize: 8, color: "#4a5568" }}>
              Tel: +65 87853373
            </Text>
            <Text style={{ fontSize: 8, color: "#4a5568" }}>
              Email: support@smart-lend.com
            </Text>
          </View>
        </View>
      </View>
      <View
        style={{
          backgroundColor: reportTheme.borderBlue,
          height: 2,
          width: "100%",
          marginTop: 10,
        }}
      />
      <View
        style={{
          backgroundColor: "#1f67b8",
          height: 5,
          width: "76%",
          marginTop: -2,
          marginLeft: "12%",
          marginBottom: 8,
          borderRadius: 99,
        }}
      />
      {title ? (
        <View style={{ paddingHorizontal: 28 }}>
          <Text
            style={{
              fontSize: 9,
              fontFamily: "Poppins",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            {title}
          </Text>
        </View>
      ) : null}
    </View>
  );

  const renderBankAnalysisPdfCurrencyLines = (summaries, renderValue) =>
    summaries.map((summary, index) => (
      <Text
        key={`${summary?.currency || "base"}-${index}`}
        style={{
          fontSize: reportBodyFontSize,
          marginTop: index === 0 ? 0 : 2,
        }}
      >
        {summary?.currency ? `${summary.currency}: ` : ""}
        {renderValue(summary)}
      </Text>
    ));

  const renderBankAnalysisPdf = () => (
    <View style={{ paddingHorizontal: 28, marginTop: 6 }}>
      {groupedBankAnalysisStatements.map((group, groupIndex) => (
        <View
          key={`bank-analysis-group-${group.groupKey}`}
          style={{ marginTop: groupIndex === 0 ? 0 : 12 }}
        >
          <View
            style={{
              backgroundColor: reportTheme.headerBlue,
              paddingHorizontal: 8,
              paddingVertical: 6,
              borderTopLeftRadius: 6,
              borderTopRightRadius: 6,
            }}
          >
            <Text
              style={{
                fontSize: reportBodyFontSize + 1,
                fontFamily: "Poppins",
                fontWeight: 700,
                color: "#ffffff",
              }}
            >
              {group.bank}
            </Text>
            <Text
              style={{
                fontSize: reportBodyFontSize,
                fontFamily: "Poppins",
                color: "#ffffff",
              }}
            >
              Account: {group.accountNumber}
            </Text>
          </View>
          <View
            style={{
              borderWidth: 1,
              borderTopWidth: 0,
              borderColor: reportTheme.borderBlue,
            }}
          >
            <View
              style={{
                flexDirection: "row",
                backgroundColor: reportTheme.headerBlue,
              }}
            >
              {[
                ["13%", "Month"],
                ["18%", "Total Deposits"],
                ["18%", "Total Withdrawals"],
                ["17%", "End Month Balance"],
                ["18%", "Lowest Daily Balance"],
                ["8%", "Loan Keywords"],
                ["8%", "Negative Bal."],
              ].map(([width, label], index, columns) => (
                <View
                  key={`bank-analysis-heading-${label}`}
                  style={{
                    width,
                    borderRightWidth: index === columns.length - 1 ? 0 : 1,
                    borderRightColor: reportTheme.borderBlue,
                    padding: 4,
                  }}
                >
                  <Text
                    style={{
                      fontSize: reportBodyFontSize,
                      fontFamily: "Poppins",
                      fontWeight: 700,
                      color: "#ffffff",
                    }}
                  >
                    {label}
                  </Text>
                </View>
              ))}
            </View>

            {group.statements.map((statement, index) => {
              const rowBg =
                index % 2 === 0 ? reportTheme.rowEven : reportTheme.rowOdd;
              const currencySummaries = getCurrencySummaries(statement);

              return (
                <View
                  key={`bank-analysis-${group.groupKey}-${statement.job_id || index}`}
                  style={{
                    flexDirection: "row",
                    borderTopWidth: 1,
                    borderTopColor: reportTheme.borderBlue,
                    backgroundColor: rowBg,
                  }}
                >
                  <View
                    style={{
                      width: "13%",
                      borderRightWidth: 1,
                      borderRightColor: reportTheme.borderBlue,
                      padding: 4,
                    }}
                  >
                    <Text style={{ fontSize: reportBodyFontSize }}>
                      {statement.statement_month_year || "-"}
                    </Text>
                  </View>
                  <View
                    style={{
                      width: "18%",
                      borderRightWidth: 1,
                      borderRightColor: reportTheme.borderBlue,
                      padding: 4,
                    }}
                  >
                    {renderBankAnalysisPdfCurrencyLines(
                      currencySummaries,
                      (summary) =>
                        formatCurrencyAmount(
                          summary?.total_deposits,
                          summary?.currency,
                          formatStatementAmount,
                        ),
                    )}
                  </View>
                  <View
                    style={{
                      width: "18%",
                      borderRightWidth: 1,
                      borderRightColor: reportTheme.borderBlue,
                      padding: 4,
                    }}
                  >
                    {renderBankAnalysisPdfCurrencyLines(
                      currencySummaries,
                      (summary) =>
                        formatCurrencyAmount(
                          summary?.total_withdrawals,
                          summary?.currency,
                          formatStatementAmount,
                        ),
                    )}
                  </View>
                  <View
                    style={{
                      width: "17%",
                      borderRightWidth: 1,
                      borderRightColor: reportTheme.borderBlue,
                      padding: 4,
                    }}
                  >
                    {renderBankAnalysisPdfCurrencyLines(
                      currencySummaries,
                      (summary) =>
                        formatCurrencyAmount(
                          summary?.end_month_balance,
                          summary?.currency,
                          formatStatementAmount,
                        ),
                    )}
                  </View>
                  <View
                    style={{
                      width: "18%",
                      borderRightWidth: 1,
                      borderRightColor: reportTheme.borderBlue,
                      padding: 4,
                    }}
                  >
                    {renderBankAnalysisPdfCurrencyLines(
                      currencySummaries,
                      (summary) => {
                        const formattedAmount = formatCurrencyAmount(
                          summary?.lowest_daily_balance?.amount,
                          summary?.currency,
                          formatStatementAmount,
                        );
                        const formattedDate = summary?.lowest_daily_balance?.date
                          ? formatStatementDate(summary.lowest_daily_balance.date)
                          : null;

                        return formattedDate
                          ? `${formattedAmount} (${formattedDate})`
                          : formattedAmount;
                      },
                    )}
                  </View>
                  <View
                    style={{
                      width: "8%",
                      borderRightWidth: 1,
                      borderRightColor: reportTheme.borderBlue,
                      padding: 4,
                    }}
                  >
                    <Text style={{ fontSize: reportBodyFontSize }}>
                      {getLoanKeywordCount(statement)}
                    </Text>
                  </View>
                  <View style={{ width: "8%", padding: 4 }}>
                    <Text style={{ fontSize: reportBodyFontSize }}>
                      {getNegativeBalanceCount(statement)}
                    </Text>
                  </View>
                </View>
              );
            })}
          </View>
        </View>
      ))}
    </View>
  );

  const renderMlcbAnalysisPdf = () => (
    <View style={{ paddingHorizontal: 28 }}>
      {mlcbAnalysisState.entries.map((entry, index) => {
        const monthsObj = entry?.months || {};
        const monthsArr = Object.entries(monthsObj)
          .map(([monthKey, status]) => ({ monthKey, status }))
          .sort((a, b) => a.monthKey.localeCompare(b.monthKey));

        return (
          <View key={`mlcb-pdf-${index}`} style={{ marginTop: index ? 12 : 6 }}>
            <View
              style={{
                backgroundColor: reportTheme.headerBlue,
                alignItems: "center",
                padding: 4,
                borderTopLeftRadius: 7,
                borderTopRightRadius: 7,
              }}
            >
              <Text
                style={{
                  fontSize: reportTitleFontSize,
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  color: "#ffffff",
                }}
              >
                {entry?.issued_by || "Issuer"}
              </Text>
            </View>
            <View
              style={{
                padding: 6,
                borderColor: reportTheme.borderBlue,
                borderLeftWidth: 1,
                borderRightWidth: 1,
                borderBottomWidth: 1,
              }}
            >
              <View style={{ flexDirection: "row", gap: 10 }}>
                <View style={{ width: "50%" }}>
                  <Text
                    style={{ fontSize: reportBodyFontSize, fontWeight: 700 }}
                  >
                    Date of Loan:
                  </Text>
                  <Text style={{ fontSize: reportBodyFontSize }}>
                    {entry?.date_of_loan || "-"}
                  </Text>
                </View>
                <View style={{ width: "50%" }}>
                  <Text
                    style={{ fontSize: reportBodyFontSize, fontWeight: 700 }}
                  >
                    Total Payable Amount:
                  </Text>
                  <Text style={{ fontSize: reportBodyFontSize }}>
                    {formatMlcbAmount(entry?.total_payable_amount)}
                  </Text>
                </View>
              </View>
              <View style={{ marginTop: 10 }}>
                <Text style={{ fontSize: reportBodyFontSize, fontWeight: 700 }}>
                  Payment Status (Monthly)
                </Text>
                {monthsArr.length ? (
                  monthsArr.map((month) => (
                    <View
                      key={month.monthKey}
                      style={{ flexDirection: "row", gap: 10, marginTop: 3 }}
                    >
                      <Text
                        style={{ fontSize: reportBodyFontSize, width: "40%" }}
                      >
                        {month.monthKey}
                      </Text>
                      <Text
                        style={{ fontSize: reportBodyFontSize, width: "60%" }}
                      >
                        {(month.status || "-").toString().toUpperCase()}
                      </Text>
                    </View>
                  ))
                ) : (
                  <Text style={{ fontSize: reportBodyFontSize, marginTop: 4 }}>
                    No monthly status found.
                  </Text>
                )}
              </View>
            </View>
          </View>
        );
      })}
    </View>
  );

  const getSpecificUserDetails = async (user_id) => {
    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/user/getSpecificUserDetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify({ user_id: user_id }),
        },
      );
      const json = await response.json();
      if (response.status === 200) {
        setBackupContactDetails(json.userData);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Helper to normalize names (so " John Tan " == "john tan")
  const norm = (s) => (s || "").trim().toLowerCase();

  // 1) Collect shareholder names
  const shareholderList =
    singpassData?.entity?.shareholders?.["shareholders-list"] ??
    singpassData?.entity?.shareholders?.["appointments-list"] ??
    [];

  const shareholderNames = new Set(
    shareholderList
      .map((s) => s?.["person-reference"]?.["person-name"]?.value)
      .filter(Boolean)
      .map(norm),
  );

  // 2) Collect appointment names (Director/Owner only)
  const appointmentList =
    singpassData?.entity?.appointments?.["appointments-list"] ?? [];

  const qualifyingAppointmentNames = new Set(
    appointmentList
      .filter((a) => {
        const role = a?.["position"]?.desc;
        return role === "Director" || role === "Owner" || role === "Partner";
      })
      .map((a) => a?.["person-reference"]?.["person-name"]?.value)
      .filter(Boolean)
      .map(norm),
  );

  // 3) Union: shareholders ∪ qualifying appointments
  const allowedNames = new Set([
    ...shareholderNames,
    ...qualifyingAppointmentNames,
  ]);

  // Debug: print what we collected
  console.log("Shareholder names:", [...shareholderNames]);
  console.log("Qualifying appointment names (Director/Owner):", [
    ...qualifyingAppointmentNames,
  ]);
  console.log("Allowed names (union):", [...allowedNames]);

  // 4) Filter combinedSingpassData; log why each included
  const filteredCombined = combinedSingpassData?.filter((d) => {
    const raw = getPersonData(d)?.name?.value;
    const name = norm(raw);

    if (!name) return false;

    if (shareholderNames.has(name)) {
      console.log("✅ Included (shareholder):", raw);
      return true;
    }
    if (qualifyingAppointmentNames.has(name)) {
      console.log("✅ Included (appointment Director/Owner):", raw);
      return true;
    }

    // Uncomment if you also want to see exclusions:
    // console.log("❌ Excluded (not shareholder/qualifying appointment):", raw);
    return false;
  });

  useEffect(() => {
    if (single || personalOnly) return;

    const corporatePeople = Array.isArray(combinedSingpassData)
      ? combinedSingpassData
      : [];
    const cbsEntries = Array.isArray(allCBSData) ? allCBSData : [];
    const includedPeople = Array.isArray(filteredCombined) ? filteredCombined : [];

    const summarizeParsedCbs = (entry) => {
      const parsed = parseReportData(entry?.cbs_data);
      return {
        hasRawCbsData: Boolean(entry?.cbs_data),
        parsedSuccessfully: Boolean(parsed),
        topLevelKeys:
          parsed && typeof parsed === "object"
            ? Object.keys(parsed).slice(0, 10)
            : [],
      };
    };

    console.groupCollapsed("[ProfileViewer][Corporate CBS Debug]");
    console.log("Available CBS entries:", cbsEntries.map((entry, index) => ({
      index,
      userId: entry?.user_id ?? null,
      name: entry?.name ?? null,
      normalizedName: norm(entry?.name),
      ...summarizeParsedCbs(entry),
    })));
    console.log(
      "People included in borrower report after shareholder/director filtering:",
      includedPeople.map((person) => getPersonData(person)?.name?.value || "(no name)"),
    );

    corporatePeople.forEach((person, index) => {
      const personName = getPersonData(person)?.name?.value || "";
      const normalizedPersonName = norm(personName);
      const exactMatch = cbsEntries.find((entry) => entry?.name === personName);
      const normalizedMatch = cbsEntries.find(
        (entry) => norm(entry?.name) === normalizedPersonName,
      );
      const includedAsShareholder = shareholderNames.has(normalizedPersonName);
      const includedAsAppointment =
        qualifyingAppointmentNames.has(normalizedPersonName);
      const includedInBorrowerReport =
        includedAsShareholder || includedAsAppointment;

      console.log(`[ProfileViewer][Corporate CBS] Person ${index + 1}`, {
        personName,
        normalizedPersonName,
        includedInBorrowerReport,
        inclusionReason: includedAsShareholder
          ? "shareholder"
          : includedAsAppointment
            ? "appointment"
            : "excluded_by_shareholder_director_filter",
        exactMatchName: exactMatch?.name ?? null,
        normalizedMatchName: normalizedMatch?.name ?? null,
        exactMatchSummary: summarizeParsedCbs(exactMatch),
        normalizedMatchSummary: summarizeParsedCbs(normalizedMatch),
      });

      if (includedInBorrowerReport && !exactMatch && normalizedMatch) {
        console.warn(
          "[ProfileViewer][Corporate CBS] Normalized CBS match exists but exact name match failed. The borrower report currently checks exact name equality before rendering the CBS section.",
          {
            personName,
            normalizedPersonName,
            normalizedMatchName: normalizedMatch?.name ?? null,
          },
        );
      }

      if (!includedInBorrowerReport && normalizedMatch) {
        console.warn(
          "[ProfileViewer][Corporate CBS] CBS data exists for this person, but they were excluded from the borrower report before the CBS section could render.",
          {
            personName,
            normalizedPersonName,
            normalizedMatchName: normalizedMatch?.name ?? null,
          },
        );
      }

      if (includedInBorrowerReport && !normalizedMatch) {
        console.warn(
          "[ProfileViewer][Corporate CBS] Person is included in the borrower report, but no CBS entry was found for them in allCBSData.",
          {
            personName,
            normalizedPersonName,
          },
        );
      }
    });
    console.groupEnd();
  }, [single, personalOnly, combinedSingpassData, allCBSData, singpassData]);

  useEffect(() => {
    if (backupContact) {
      getSpecificUserDetails(backupContact);
    }
  }, [backupContact]);

  return (
    <div className="profile-viewer">
      <div className="profile-viewer__header">
        <span className="profile-viewer__header-icon">
          <PersonOutlineIcon fontSize="small" />
        </span>
        <h2> Borrower information</h2>
      </div>
      <PropertyApplicationComments comments={applicationComments} />
      {propertyProfileId && (
        <section className="profile-viewer__property-owners" aria-label="Property Myinfo profiles">
          <h3>Keyman &amp; Co-owners</h3>
          {propertyProfiles.loading && <p role="status">Loading Myinfo profiles…</p>}
          {propertyProfiles.error && <p role="alert">{propertyProfiles.error}</p>}
          <div className="profile-viewer__user-tabs" role="tablist" aria-label="Property owners">
            {[{ ...(propertyProfiles.keyman || {}), id: "keyman", role: "Keyman", name: propertyProfiles.keyman?.name || getMyInfoData(myinfoData)?.name?.value || "Main applicant" }, ...propertyProfiles.co_owners].map(person => (
              <button key={person.id} type="button" role="tab"
                aria-selected={(selectedPropertyPerson?.id || "keyman") === person.id}
                className={`profile-viewer__user-tab all_button ${(selectedPropertyPerson?.id || "keyman") === person.id ? "is-active" : ""}`}
                onClick={() => { setPropertyPerson({ applicationId: propertyProfileId, id: person.id }); setViewingTab(0); }}>
                {person.name} ({person.role})
              </button>
            ))}
          </div>
          {!propertyProfiles.loading && !propertyProfiles.co_owners.length && !propertyProfiles.error && <p>No co-owner Myinfo has been shared for this case.</p>}
        </section>
      )}
      {single || personalOnly ? null : (
        <div style={{ display: "flex", marginTop: "10px" }}>
          <div className="profile-viewer__keyman">
            <BadgeOutlinedIcon fontSize="small" />
            Loan keyman: {keyman ? keyman : ""}
          </div>
        </div>
      )}
      {single || personalOnly ? null : (
        <div
          className="profile-viewer__user-tabs"
          style={{ overflowX: isMobile ? "auto" : "hidden" }}
        >
          <div
            className={`profile-viewer__user-tab all_button ${
              viewingUser === 0 ? "is-active" : ""
            }`}
            onClick={() => {
              setViewingUser(0);
              console.log(singpassData);
              setLiveUserData(singpassData);
            }}
          >
            {getPersonData(singpassData)?.name?.value !== undefined
              ? getPersonData(singpassData)?.name?.value
              : null}
          </div>

          {otherAuthoriserDetails
            ? otherAuthoriserDetails.map((aut, index) => (
                <div
                  className={`profile-viewer__user-tab all_button ${
                    viewingUser === index + 1 ? "is-active" : ""
                  }`}
                  onClick={() => {
                    setViewingUser(index + 1);
                    console.log(JSON.parse(aut.singpass_data));
                    setLiveUserData(JSON.parse(aut.singpass_data));
                  }}
                  key={index}
                >
                  {aut.director_name}
                </div>
              ))
            : null}
        </div>
      )}
      {showConciergeNotice ? (
        <div
          role="note"
          style={{
            margin: "16px 0",
            padding: "12px 16px",
            border: "1px solid #bfdbfe",
            borderRadius: "10px",
            backgroundColor: "#eff6ff",
            color: "#1e3a8a",
            fontSize: "14px",
            lineHeight: 1.6,
          }}
        >
          This loan is managed through our concierge service. The borrower’s
          personal information and mobile number are not displayed. Please contact
          a SmartLend consultant for assistance.
        </div>
      ) : null}
      {availableTab?.length ? (
        <div
          className="profile-viewer__tab-bar"
          style={{ overflowX: isMobile ? "auto" : "auto" }}
        >
          {availableTab.map((view, index) =>
            view.name === "Customer Document Analysis" &&
            !bankAnalysisContext?.enabled ? null : personalOnly &&
              hiddenPersonalTabs.has(view.name) ? null : view.name ===
                "MLCB Analysis" && !mlcbAnalysisContext?.enabled ? null : (
              <div
                onClick={() => {
                  setViewingTab(index);
                }}
                className={`profile-viewer__tab all_button ${
                  viewingTab === index ? "is-active" : ""
                }`}
                key={index}
              >
                {/* <span className="profile-viewer__tab-icon">
                  {getTabIcon(view.name)}
                </span> */}
                <span>{view.name}</span>
                {view.isNew ? (
                  <span className="profile-viewer__tab-badge">New</span>
                ) : null}
              </div>
            ),
          )}
        </div>
      ) : null}
      <div
        key={propertyProfileId ? `${propertyProfileId}:${selectedPropertyPerson?.id || "keyman"}` : undefined}
        style={{
          padding: "15px 0px",
          overflowX: isMobile ? "auto" : "hidden",
        }}
      >
        {hasProfileViewerContent ? (
          viewingTab === 0 ? (
            <div
              className="profile-viewer__info-card"
              style={{
                padding: "15px 15px",
                borderRadius: "8px",
                width: "100%",
                background: "rgba(109, 92, 246, 0.1)",
                display: "flex",
                flexWrap: "wrap",
                gap: "2px 20px",
              }}
            >
              <div className="profile-viewer__section">
                <div className="profile-viewer__section-title">
                  Personal information
                </div>
                <div className="profile-viewer__section-body">
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      NRIC
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        min={0}
                        // className={nricError ? "error-border" : ""}
                        value={profileData?.uinfin?.value}
                      />
                      {/* {nricError && <div style={{ color: 'red' }}>Please fill in the NRIC</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Full Name
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        type="text"
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        value={profileData?.name?.value}
                        // required
                      />
                      {/* {fullNameError && <div style={{ color: 'red' }}>Please fill in the Full Name</div>} */}
                    </div>
                  </div>
                  {sisterCompanyIncome ? (
                    <div
                      style={{
                        width: "40%",
                        display: "flex",
                        marginBottom: 10,
                      }}
                    >
                      <div
                        style={{
                          width: "40%",
                          color: "rgba(20, 44, 68, 0.8)",
                          fontWeight: 800,
                          fontFamily: "Manrope, sans-serif",
                          fontSize: 14,
                        }}
                      >
                        {sisterCompanyIncome.label}
                      </div>
                      <div style={{ width: "60%" }}>
                        <input
                          type="text"
                          style={{
                            width: "100%",
                            borderRadius: "10px",
                            border: "none",
                            outline: "none",
                            padding: 7,
                          }}
                          disabled
                          value={formatCurrency(sisterCompanyIncome.value)}
                        />
                      </div>
                    </div>
                  ) : null}
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Sex
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        value={profileData?.sex?.desc}
                        // required
                      />
                      {/* {sexError && <div style={{ color: 'red' }}>Please fill in the Sex</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Race
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.race?.desc}
                      />
                      {/* {raceError && <div style={{ color: 'red' }}>Please fill in the Race</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Nationality
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.nationality?.desc}
                      />
                      {/* {nationalityError && <div style={{ color: 'red' }}>Please fill in the Nationality</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Date of Birth
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="date"
                        // required
                        value={profileData?.dob?.value}
                      />
                      {/* {dobError && <div style={{ color: 'red' }}>Please fill in the Date Of Birth</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Country of Birth
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.birthcountry?.desc}
                      />
                      {/* {highestEducationLevelError && <div style={{ color: 'red' }}>Please fill in the Highest Education Level</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Residential Status
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.residentialstatus?.desc}
                      />
                      {/* {highestEducationLevelError && <div style={{ color: 'red' }}>Please fill in the Highest Education Level</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Pass type
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.passtype?.desc}
                      />
                      {/* {highestEducationLevelError && <div style={{ color: 'red' }}>Please fill in the Highest Education Level</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Pass Status
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.passstatus?.value}
                      />
                      {/* {highestEducationLevelError && <div style={{ color: 'red' }}>Please fill in the Highest Education Level</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Pass Expiry Date
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="date"
                        // required
                        value={profileData?.passexpirydate?.value}
                      />
                      {/* {dobError && <div style={{ color: 'red' }}>Please fill in the Date Of Birth</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Ownership of Private Property Status
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={formatOwnerPrivate(
                          profileData?.ownerprivate?.value,
                        )}
                      />
                      {/* {highestEducationLevelError && <div style={{ color: 'red' }}>Please fill in the Highest Education Level</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Email
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        type="email"
                        disabled
                        // required
                        value={getDisplayEmail(profileData?.email?.value)}
                      />
                      {/* {emailError && <div style={{ color: 'red' }}>Please fill in the Email</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Mobile Number
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type={personalOnly ? "text" : "number"}
                        // required
                        value={getDisplayMobile(
                          formatMobileNumber(profileData),
                        )}
                      />
                      {/* {mobileNoError && <div style={{ color: 'red' }}>Please fill in the Mobile Number</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Registered Address
                    </div>
                    <div style={{ width: "60%" }}>
                      <textarea
                        rows="2"
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        // required
                        value={formatAddress(profileData?.regadd)}
                      ></textarea>
                      {/* {registeredAddressError && <div style={{ color: 'red' }}>Please fill in the Registered Address</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Marital Status
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        value={profileData?.marital?.desc}
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Occupation
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.occupation?.value}
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile-viewer__section">
                <div className="profile-viewer__section-title">
                  Housing &amp; HDB
                </div>
                <div className="profile-viewer__section-body">
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Housing Type
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.housingtype?.desc}
                      />
                      {/* {housingTypeError && <div style={{ color: 'red' }}>Please fill in the Housing Type</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Employer's name
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          personalOnly ? profileData?.employment?.value : ""
                        }
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Employment Sector
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          personalOnly
                            ? profileData?.employmentsector?.value
                            : ""
                        }
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      HDB Type
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.hdbtype?.desc}
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Housing Type
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.housingtype?.desc}
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                  {profileData?.hdbownership?.map((hdb, index) => (
                    <div
                      key={index}
                      style={{
                        width: "83.5%",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          HDB Ownership {index + 1} - Address
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="text"
                            // required
                            value={formatAddress(hdb?.address)}
                          />
                          {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                        </div>
                      </div>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          HDB Ownership {index + 1} - Outstanding HDB Loan
                          Balance
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="text"
                            // required
                            value={hdb?.outstandingloanbalance?.value?.toLocaleString(
                              "en-US",
                              {
                                style: "currency",
                                currency: "SGD",
                              },
                            )}
                          />
                          {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                        </div>
                      </div>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          HDB Ownership {index + 1} - Type of HDB Dwelling
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="text"
                            // required
                            value={hdb?.hdbtype?.desc}
                          />
                          {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                        </div>
                      </div>
                      <div
                        style={{
                          width: "50%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          HDB Ownership {index + 1} - Monthly Loan Installment
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="text"
                            // required
                            value={hdb?.monthlyloaninstalment?.value?.toLocaleString(
                              "en-US",
                              {
                                style: "currency",
                                currency: "SGD",
                              },
                            )}
                          />
                          {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="profile-viewer__section">
                <div className="profile-viewer__section-title">Vehicles</div>
                <div className="profile-viewer__section-body">
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Vehicles - Vehicles Model
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.vehicles?.[0]?.model?.value}
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Vehicles - Vehicles Make
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={profileData?.vehicles?.[0]?.make?.value}
                      />
                      {/* {maritalStatusError && <div style={{ color: 'red' }}>Please fill in the Marital Status</div>} */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="profile-viewer__section">
                <div className="profile-viewer__section-title">CPF</div>
                <div className="profile-viewer__section-body">
                  {profileData?.cpfhousingwithdrawal?.withdrawaldetails?.map(
                    (cpf, index) => (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexWrap: "wrap",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          CPF Usage{" "}
                          {(cpf.address.unit?.value !== undefined
                            ? `Unit ${cpf.address.unit?.value}, `
                            : "") +
                            (cpf.address.floor?.value !== undefined
                              ? `Floor ${cpf.address.floor?.value}, `
                              : "") +
                            (cpf.address.block?.value !== undefined
                              ? `Block ${cpf.address.block?.value}, `
                              : "") +
                            (cpf.address.street?.value !== undefined
                              ? `${cpf.address.street?.value}, `
                              : "") +
                            (cpf.address.postal?.value !== undefined
                              ? `${cpf.address.postal?.value}, `
                              : "") +
                            (cpf.address.country?.desc !== undefined
                              ? `${cpf.address.country?.desc}.`
                              : "")}
                          :
                        </div>
                        <div
                          style={{
                            width: "42%",
                            display: "flex",
                            marginBottom: 10,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              color: "rgba(20, 44, 68, 0.8)",
                              fontWeight: 800,
                              fontFamily: "Manrope, sans-serif",
                              fontSize: 14,
                            }}
                          >
                            Principal Withdrawal Amount:
                          </div>
                          <div style={{ width: "40%" }}>
                            <input
                              style={{
                                width: "100%",
                                borderRadius: "10px",
                                border: "none",
                                outline: "none",
                                padding: 7,
                              }}
                              disabled
                              type="text"
                              // required
                              value={cpf?.principalwithdrawalamt?.value?.toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "SGD",
                                },
                              )}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            width: "42%",
                            display: "flex",
                            marginBottom: 10,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              color: "rgba(20, 44, 68, 0.8)",
                              fontWeight: 800,
                              fontFamily: "Manrope, sans-serif",
                              fontSize: 14,
                            }}
                          >
                            Accrued Interest Amount:
                          </div>
                          <div style={{ width: "40%" }}>
                            <input
                              style={{
                                width: "100%",
                                borderRadius: "10px",
                                border: "none",
                                outline: "none",
                                padding: 7,
                              }}
                              disabled
                              type="text"
                              // required
                              value={cpf?.accruedinterestamt?.value?.toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "SGD",
                                },
                              )}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            width: "42%",
                            display: "flex",
                            marginBottom: 10,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              color: "rgba(20, 44, 68, 0.8)",
                              fontWeight: 800,
                              fontFamily: "Manrope, sans-serif",
                              fontSize: 14,
                            }}
                          >
                            Monthly Installment (CPF):
                          </div>
                          <div style={{ width: "40%" }}>
                            <input
                              style={{
                                width: "100%",
                                borderRadius: "10px",
                                border: "none",
                                outline: "none",
                                padding: 7,
                              }}
                              disabled
                              type="text"
                              // required
                              value={cpf?.monthlyinstalmentamt?.value?.toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "SGD",
                                },
                              )}
                            />
                          </div>
                        </div>
                        <div
                          style={{
                            width: "42%",
                            display: "flex",
                            marginBottom: 10,
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              color: "rgba(20, 44, 68, 0.8)",
                              fontWeight: 800,
                              fontFamily: "Manrope, sans-serif",
                              fontSize: 14,
                            }}
                          >
                            Total Amount of CPF Allowed For Property:
                          </div>
                          <div style={{ width: "40%" }}>
                            <input
                              style={{
                                width: "100%",
                                borderRadius: "10px",
                                border: "none",
                                outline: "none",
                                padding: 7,
                              }}
                              disabled
                              type="text"
                              // required
                              value={cpf?.totalamountofcpfallowedforproperty?.value?.toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "SGD",
                                },
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                </div>
              </div>
              {personalOnly ? (
                <>
                  <div className="profile-viewer__section">
                    <div className="profile-viewer__section-title">
                      CPF Account Details
                    </div>
                    <div className="profile-viewer__section-body">
                      {Object.keys(profileData?.cpfbalances || {}).map(
                        (accountKey) => (
                          <div
                            key={accountKey}
                            style={{
                              width: "40%",
                              display: "flex",
                              marginBottom: 10,
                            }}
                          >
                            <div
                              style={{
                                width: "40%",
                                color: "rgba(20, 44, 68, 0.8)",
                                fontWeight: 800,
                                fontFamily: "Manrope, sans-serif",
                                fontSize: 14,
                              }}
                            >
                              CPF {accountKey.toUpperCase()} Balance
                            </div>
                            <div style={{ width: "60%" }}>
                              <input
                                style={{
                                  width: "100%",
                                  borderRadius: "10px",
                                  border: "none",
                                  outline: "none",
                                  padding: 7,
                                }}
                                disabled
                                type="text"
                                value={formatCurrency(
                                  profileData?.cpfbalances?.[accountKey]?.value,
                                )}
                              />
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                  <div className="profile-viewer__section">
                    <div className="profile-viewer__section-title">
                      CPF Contributions
                    </div>
                    <div className="profile-viewer__section-body">
                      {profileData?.cpfcontributions?.history?.length ? (
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "separate",
                            borderRadius: "10px",
                            overflow: "hidden",
                            padding: "10px",
                            borderSpacing: "0px",
                            background: "#6d5cf61A",
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "rgba(20, 44, 68, 0.8)",
                                fontWeight: 800,
                                fontFamily: "Manrope, sans-serif",
                                fontSize: 12,
                              }}
                            >
                              <th style={{ padding: "5px 10px" }}>Employer</th>
                              <th style={{ padding: "5px 10px" }}>Paid On</th>
                              <th style={{ padding: "5px 10px" }}>
                                Contribution Month
                              </th>
                              <th style={{ padding: "5px 10px" }}>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {profileData?.cpfcontributions?.history?.map(
                              (entry, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {entry?.employer?.value}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatDateValue(entry?.date?.value)}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatYearMonth(entry?.month?.value)}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatCurrency(entry?.amount?.value)}
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      ) : (
                        <div style={{ color: "rgba(20, 44, 68, 0.6)" }}>
                          No CPF contribution history available.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="profile-viewer__section">
                    <div className="profile-viewer__section-title">
                      NOA History
                    </div>
                    <div className="profile-viewer__section-body">
                      {profileData?.noahistory?.noas?.length ? (
                        <table
                          style={{
                            width: "100%",
                            borderCollapse: "separate",
                            borderRadius: "10px",
                            overflow: "hidden",
                            padding: "10px",
                            borderSpacing: "0px",
                            background: "#6d5cf61A",
                          }}
                        >
                          <thead>
                            <tr
                              style={{
                                color: "rgba(20, 44, 68, 0.8)",
                                fontWeight: 800,
                                fontFamily: "Manrope, sans-serif",
                                fontSize: 12,
                              }}
                            >
                              <th style={{ padding: "5px 10px" }}>
                                Year of Assessment
                              </th>
                              <th style={{ padding: "5px 10px" }}>Trade</th>
                              <th style={{ padding: "5px 10px" }}>Interest</th>
                              <th style={{ padding: "5px 10px" }}>
                                Employment
                              </th>
                              <th style={{ padding: "5px 10px" }}>Rent</th>
                              <th style={{ padding: "5px 10px" }}>Amount</th>
                              <th style={{ padding: "5px 10px" }}>Category</th>
                            </tr>
                          </thead>
                          <tbody>
                            {profileData?.noahistory?.noas?.map(
                              (entry, index) => (
                                <tr key={index}>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {entry?.yearofassessment?.value}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatCurrency(entry?.trade?.value)}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatCurrency(entry?.interest?.value)}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatCurrency(entry?.employment?.value)}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatCurrency(entry?.rent?.value)}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {formatCurrency(entry?.amount?.value)}
                                  </td>
                                  <td
                                    style={{
                                      borderTop: "1px solid rgba(0,0,0,0.6)",
                                      padding: "5px 10px",
                                    }}
                                  >
                                    {entry?.category?.value}
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                      ) : (
                        <div style={{ color: "rgba(20, 44, 68, 0.6)" }}>
                          No NOA history available.
                        </div>
                      )}
                    </div>
                  </div>
                  {loanDocuments ? (
                    <div className="profile-viewer__section">
                      <div className="profile-viewer__section-title">
                        Payslip documents
                      </div>
                      <div className="profile-viewer__section-body">
                        {payslipDocuments.length ? (
                          <ul style={{ margin: 0, paddingLeft: 18 }}>
                            {payslipDocuments.map((doc, index) => (
                              <li
                                key={doc?.document_id || doc?.file_url || index}
                              >
                                {doc?.file_url ? (
                                  <a
                                    href={doc.file_url}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {doc?.file_name || "Payslip document"}
                                  </a>
                                ) : (
                                  doc?.file_name || "Payslip document"
                                )}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <div style={{ color: "rgba(20, 44, 68, 0.6)" }}>
                            No payslip documents uploaded.
                          </div>
                        )}
                      </div>
                    </div>
                  ) : null}
                </>
              ) : null}
            </div>
          ) : viewingTab === 1 ? (
            <div
              style={{
                padding: "15px 15px",
                borderRadius: "8px",
                width: "100%",
                background: "rgba(109, 92, 246, 0.1)",
                display: "flex",
                flexWrap: "wrap",
                gap: "2px 20px",
              }}
            >
              <div className="profile-viewer__section">
                <div className="profile-viewer__section-title">
                  Corporate information
                </div>
                <div className="profile-viewer__section-body">
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      UEN
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          liveUserData?.entity?.["basic-profile"]?.uen?.value
                        }
                      />
                      {/* {uenError && <div style={{ color: 'red' }}>Please fill in the UEN</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Entity Name
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          liveUserData?.entity?.["basic-profile"]["entity-name"]
                            ?.value
                        }
                      />
                      {/* {entityNameError && <div style={{ color: 'red' }}>Please fill in the Entity Name</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Entity Type
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          liveUserData?.entity?.["basic-profile"]["entity-type"]
                            ?.value
                        }
                      />
                      {/* {entityTypeError && <div style={{ color: 'red' }}>Please fill in the Entity Type</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Entity Status
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          liveUserData?.entity?.["basic-profile"][
                            "entity-status"
                          ]?.value
                        }
                      />
                      {/* {entityStatusError && <div style={{ color: 'red' }}>Please fill in the Entity Status</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Registered Address
                    </div>
                    <div style={{ width: "60%" }}>
                      <textarea
                        rows="2"
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                          resize: "none",
                        }}
                        disabled
                        // required
                        value={
                          liveUserData?.entity?.addresses["addresses-list"][0]
                            ? (liveUserData?.entity?.addresses?.[
                                "addresses-list"
                              ]?.[0]?.unit?.value !== undefined
                                ? `Unit ${liveUserData?.entity?.addresses?.["addresses-list"]?.[0]?.unit?.value}, `
                                : "") +
                              (liveUserData?.entity?.addresses?.[
                                "addresses-list"
                              ]?.[0]?.floor?.value !== undefined
                                ? `Floor ${liveUserData?.entity?.addresses?.["addresses-list"]?.[0]?.floor?.value}, `
                                : "") +
                              (liveUserData?.entity?.addresses?.[
                                "addresses-list"
                              ]?.[0]?.block?.value !== undefined
                                ? `Block ${liveUserData?.entity?.addresses?.["addresses-list"]?.[0]?.block?.value}, `
                                : "") +
                              (liveUserData?.entity?.addresses?.[
                                "addresses-list"
                              ]?.[0]?.street?.value !== undefined
                                ? `${liveUserData?.entity?.addresses?.["addresses-list"]?.[0]?.street?.value}, `
                                : "") +
                              (liveUserData?.entity?.addresses?.[
                                "addresses-list"
                              ]?.[0]?.postal?.value !== undefined
                                ? `${liveUserData?.entity?.addresses?.["addresses-list"]?.[0]?.postal?.value}, `
                                : "") +
                              (liveUserData?.entity?.addresses?.[
                                "addresses-list"
                              ]?.[0]?.country?.desc !== undefined
                                ? `${liveUserData?.entity?.addresses?.["addresses-list"]?.[0]?.country?.desc}.`
                                : "")
                            : ""
                        }
                      ></textarea>
                      {/* {registeredAddressEntityError && <div style={{ color: 'red' }}>Please fill in the Registered Address</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Registration Date
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="date"
                        // required
                        value={
                          liveUserData?.entity?.["basic-profile"][
                            "registration-date"
                          ]?.value
                        }
                      />
                      {/* {registrationDateError && <div style={{ color: 'red' }}>Please fill in the Registered Date</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Primary SSIC
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          liveUserData?.entity?.["basic-profile"][
                            "primary-activity"
                          ]?.desc
                        }
                      />
                      {/* {primarySSICError && <div style={{ color: 'red' }}>Please fill in the Primary SSIC</div>} */}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40%",
                      display: "flex",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        width: "40%",
                        color: "rgba(20, 44, 68, 0.8)",
                        fontWeight: 800,
                        fontFamily: "Manrope, sans-serif",
                        fontSize: 14,
                      }}
                    >
                      Secondary SSIC
                    </div>
                    <div style={{ width: "60%" }}>
                      <input
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          border: "none",
                          outline: "none",
                          padding: 7,
                        }}
                        disabled
                        type="text"
                        // required
                        value={
                          liveUserData?.entity?.["basic-profile"][
                            "secondary-activity"
                          ]?.desc
                        }
                      />
                      {/* {secondarySSICError && <div style={{ color: 'red' }}>Please fill in the Secondary SSIC</div>} */}
                    </div>
                  </div>
                </div>
              </div>
              {liveUserData?.entity?.appointments["appointments-list"]?.map(
                (appointment, index) => (
                  <div
                    className="profile-viewer__section"
                    style={{
                      width: "100%",
                    }}
                    key={index}
                  >
                    <div className="profile-viewer__section-title">
                      Appointment {index + 1}
                    </div>
                    <div className="profile-viewer__section-body">
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          Appointment {index + 1} - Position
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="text"
                            value={appointment.position.desc}
                            // Add onChange logic if needed
                          />
                        </div>
                      </div>
                      {/* Similar structure for NRIC, Full Name, and Appointment Date */}
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          Appointment {index + 1} - NRIC
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="text"
                            value={
                              appointment["person-reference"]
                                ? appointment["person-reference"].idno.value
                                : appointment["entity-reference"]
                                  ? appointment["entity-reference"].uen.value
                                  : null
                            }
                            // Add onChange logic if needed
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          Appointment {index + 1} - Full Name
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="text"
                            value={
                              appointment["person-reference"]
                                ? appointment["person-reference"]["person-name"]
                                    .value
                                : appointment["entity-reference"]
                                  ? appointment["entity-reference"][
                                      "entity-name"
                                    ].value
                                  : null
                            }
                            // Add onChange logic if needed
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          width: "40%",
                          display: "flex",
                          marginBottom: 10,
                        }}
                      >
                        <div
                          style={{
                            width: "40%",
                            color: "rgba(20, 44, 68, 0.8)",
                            fontWeight: 800,
                            fontFamily: "Manrope, sans-serif",
                            fontSize: 14,
                          }}
                        >
                          Appointment {index + 1} - Appointment Date
                        </div>
                        <div style={{ width: "60%" }}>
                          <input
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "none",
                              outline: "none",
                              padding: 7,
                            }}
                            disabled
                            type="date"
                            value={appointment["appointment-date"].value}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ),
              )}
            </div>
          ) : viewingTab === 2 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderRadius: "10px",
                overflow: "hidden",
                padding: "10px",
                borderSpacing: "0px",
                background: "#6d5cf61A",
              }}
            >
              <thead
                style={{
                  borderRadius: "15px 15px 0px 0px",
                  border: "none",
                  borderRadius: "8px",
                }}
              >
                <tr
                  style={{
                    border: "none",
                    borderRadius: "8px",
                    color: "rgba(20, 44, 68, 0.8)",
                    fontWeight: 800,
                    fontFamily: "Manrope, sans-serif",
                    fontSize: 12,
                    borderRadius: 8,
                  }}
                >
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Amount
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Category
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Employment
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Interest
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Rent
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Tax Clearance
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Trade
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Years of Assessment
                  </th>
                </tr>
              </thead>
              <tbody>
                {profileData?.noahistory?.noas?.map((item, index) => (
                  <tr key={index}>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.amount?.value?.toLocaleString("en-US", {
                        style: "currency",
                        currency: "SGD",
                      })}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.category?.value}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.employment?.value?.toLocaleString("en-US")}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.interest?.value?.toLocaleString("en-US")}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.rent?.value?.toLocaleString("en-US")}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.taxclearance?.value}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.trade?.value?.toLocaleString("en-US")}
                    </td>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        padding: "5px 10px",
                      }}
                    >
                      {item?.yearofassessment?.value}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : viewingTab === 3 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderRadius: "10px",
                overflow: "hidden",
                padding: "10px",
                borderSpacing: "0px",
                background: "#6d5cf61A",
              }}
            >
              <thead
                style={{
                  borderRadius: "15px 15px 0px 0px",
                  border: "none",
                  borderRadius: "8px",
                }}
              >
                <tr
                  style={{
                    border: "none",
                    borderRadius: "8px",
                    color: "rgba(20, 44, 68, 0.8)",
                    fontWeight: 800,
                    fontFamily: "Manrope, sans-serif",
                    fontSize: 12,
                    borderRadius: 8,
                  }}
                >
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Capital Type
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Currency
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Issued Capital Amount
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Paid Up Capital Amount
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Share Alloted Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {liveUserData?.entity?.capitals["capitals-list"]?.map(
                  (item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["capital-type"]?.desc}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.currency?.desc}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["issued-capital-amount"]?.value?.toLocaleString(
                          "en-US",
                          {
                            style: "currency",
                            currency: "SGD",
                          },
                        )}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.[
                          "paid-up-capital-amount"
                        ]?.value?.toLocaleString("en-US", {
                          style: "currency",
                          currency: "SGD",
                        })}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["share-allotted-amount"]?.value?.toLocaleString(
                          "en-US",
                        )}
                      </td>
                      {/* Add other data cells */}
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          ) : viewingTab === 4 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderRadius: "10px",
                overflow: "hidden",
                padding: "10px",
                borderSpacing: "0px",
                background: "#6d5cf61A",
              }}
            >
              <thead
                style={{
                  borderRadius: "15px 15px 0px 0px",
                  border: "none",
                  borderRadius: "8px",
                }}
              >
                <tr
                  style={{
                    border: "none",
                    borderRadius: "8px",
                    color: "rgba(20, 44, 68, 0.8)",
                    fontWeight: 800,
                    fontFamily: "Manrope, sans-serif",
                    fontSize: 12,
                    borderRadius: 8,
                  }}
                >
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Company Profit Loss After Tax
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Company Profit Loss Before Tax
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Company Revenue
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Currency
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Current Period End Date
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Current Period Start Date
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Group Capital Paid Up Capital Amount
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Group Profit Loss After Tax
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Group Profit Loss Before Tax
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Group Revenue
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Is Audited
                  </th>
                </tr>
              </thead>
              <tbody>
                {liveUserData?.entity?.financials?.highlights?.map(
                  (item, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["company-profit-loss-after-tax"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["company-profit-loss-before-tax"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["company-revenue"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.currency?.desc}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["current-period-end-date"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["current-period-start-date"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["group-capital-paid-up-capital-amount"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["group-profit-loss-after-tax"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["group-profit-loss-before-tax"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["group-revenue"]?.value}
                      </td>
                      <td
                        style={{
                          borderTop: "1px solid rgba(0,0,0,0.6)",
                          padding: "5px 10px",
                        }}
                      >
                        {item?.["is-audited"]?.value}
                      </td>
                    </tr>
                  ),
                )}
              </tbody>
            </table>
          ) : viewingTab === 5 ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "separate",
                borderRadius: "10px",
                overflow: "hidden",
                padding: "10px",
                borderSpacing: "0px",
                background: "#6d5cf61A",
              }}
            >
              <thead
                style={{
                  borderRadius: "15px 15px 0px 0px",
                  border: "none",
                  borderRadius: "8px",
                }}
              >
                <tr
                  style={{
                    border: "none",
                    borderRadius: "8px",
                    color: "rgba(20, 44, 68, 0.8)",
                    fontWeight: 800,
                    fontFamily: "Manrope, sans-serif",
                    fontSize: 12,
                    borderRadius: 8,
                  }}
                >
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Allocation
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Category
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Name
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    NRIC
                  </th>
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Currency
                  </th>
                  {/* <th style={{ border: '1px solid rgba(0,0,0,0.6)' }}>Person Reference NRIC</th>
  <th style={{ border: '1px solid rgba(0,0,0,0.6)' }}>Person Reference Nationality</th>
  <th style={{ border: '1px solid rgba(0,0,0,0.6)' }}>Person Reference Name</th> */}
                  <th
                    style={{
                      padding: "5px 10px",
                    }}
                  >
                    Share Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {liveUserData?.entity?.shareholders["shareholders-list"] ? (
                  liveUserData?.entity?.shareholders["shareholders-list"]?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.allocation?.value?.toLocaleString("en-US")}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.category?.desc}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.["person-reference"]?.["person-name"]?.value}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.["person-reference"]?.idno?.value}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.currency?.desc}
                        </td>
                        {/* <td style={{ borderTop: '1px solid rgba(0,0,0,0.6)' }}>{item?["person-reference"].idno.value}</td>
  <td style={{ borderTop: '1px solid rgba(0,0,0,0.6)' }}>{item?["person-reference"].nationality.desc}</td>
  <td style={{ borderTop: '1px solid rgba(0,0,0,0.6)' }}>{item?["person-reference"]["person-name"].value}</td> */}
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.["share-type"]?.desc}
                        </td>
                      </tr>
                    ),
                  )
                ) : liveUserData?.entity?.shareholders["appointments-list"] ? (
                  liveUserData?.entity?.shareholders["appointments-list"]?.map(
                    (item, index) => (
                      <tr key={index}>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.allocation?.value?.toLocaleString("en-US")}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.category?.desc}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.["person-reference"]?.["person-name"]?.value}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.["person-reference"]?.idno?.value}
                        </td>
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.currency?.desc}
                        </td>
                        {/* <td style={{ borderTop: '1px solid rgba(0,0,0,0.6)' }}>{item?["person-reference"].idno.value}</td>
  <td style={{ borderTop: '1px solid rgba(0,0,0,0.6)' }}>{item?["person-reference"].nationality.desc}</td>
  <td style={{ borderTop: '1px solid rgba(0,0,0,0.6)' }}>{item?["person-reference"]["person-name"].value}</td> */}
                        <td
                          style={{
                            borderTop: "1px solid rgba(0,0,0,0.6)",
                            padding: "5px 10px",
                          }}
                        >
                          {item?.["share-type"]?.desc}
                        </td>
                      </tr>
                    ),
                  )
                ) : (
                  <tr>
                    <td
                      style={{
                        borderTop: "1px solid rgba(0,0,0,0.6)",
                        textAlign: "center",
                        padding: "5px 10px",
                      }}
                      colSpan="11"
                    >
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          ) : viewingTab === analysisTabIndex ? (
            <>
              {bankAnalysisContext?.loanType === "property" && bankAnalysisState.pendingCount > 0 && (
                <p role="status">
                  Processing {bankAnalysisState.pendingCount} bank statement{bankAnalysisState.pendingCount === 1 ? "" : "s"}.
                  {" "}Results will appear automatically when ready.
                </p>
              )}
              <BankStatementAnalysisPanel
                enabled={bankAnalysisContext?.enabled}
                loading={bankAnalysisState.loading}
                error={bankAnalysisState.error}
                statementGroups={groupedBankAnalysisStatements}
                isMobile={isMobile}
                formatAmount={formatStatementAmount}
                formatDate={formatStatementDate}
              />
            </>
          ) : viewingTab === mlcbAnalysisTabIndex ? (
            <div
              style={{
                padding: "15px 15px",
                borderRadius: "8px",
                width: "100%",
                background: "rgba(109, 92, 246, 0.1)",
                display: "flex",
                flexDirection: "column",
                gap: "12px",
              }}
            >
              {!mlcbAnalysisContext?.enabled ? (
                <div className="profile-viewer__analysis-muted">
                  MLCB analysis is not available for this request.
                </div>
              ) : mlcbAnalysisState.loading ? (
                <div className="profile-viewer__analysis-muted">
                  Loading MLCB analysis...
                </div>
              ) : mlcbAnalysisState.error ? (
                <div className="profile-viewer__analysis-error">
                  {mlcbAnalysisState.error}
                </div>
              ) : mlcbAnalysisState.entries.length === 0 ? (
                <div className="profile-viewer__analysis-muted">
                  No MLCB analysis available.
                </div>
              ) : (
                mlcbAnalysisState.entries.map((entry, index) => {
                  const monthsObj = entry?.months || {};

                  // Convert { "2025-03": "OK", ... } into sortable array
                  const monthsArr = Object.entries(monthsObj)
                    .map(([monthKey, status]) => ({ monthKey, status }))
                    .sort((a, b) => a.monthKey.localeCompare(b.monthKey));

                  const formatMonthKeyShort = (monthKey) => {
                    if (!monthKey || typeof monthKey !== "string") return "-";

                    const [yyyy, mm] = monthKey.split("-");
                    if (!yyyy || !mm) return monthKey;

                    const monthIndex = parseInt(mm, 10) - 1;
                    if (
                      Number.isNaN(monthIndex) ||
                      monthIndex < 0 ||
                      monthIndex > 11
                    )
                      return monthKey;

                    const monthNames = [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ];
                    const yy = yyyy.slice(-2);

                    return `${monthNames[monthIndex]} ${yy}`;
                  };

                  return (
                    <div
                      key={`mlcb-entry-${index}`}
                      className="profile-viewer__section"
                    >
                      <div className="profile-viewer__section-title">
                        {entry?.issued_by || "Issuer"}
                      </div>

                      {/* Summary row */}
                      <div
                        className="profile-viewer__analysis-grid"
                        style={{
                          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr",
                        }}
                      >
                        <div>
                          <div className="profile-viewer__analysis-label">
                            Issued By
                          </div>
                          <div className="profile-viewer__analysis-value">
                            {entry?.issued_by || "-"}
                          </div>
                        </div>

                        <div>
                          <div className="profile-viewer__analysis-label">
                            Date of Loan
                          </div>
                          <div className="profile-viewer__analysis-value">
                            {entry?.date_of_loan || "-"}
                          </div>
                        </div>

                        <div>
                          <div className="profile-viewer__analysis-label">
                            Total Payable Amount
                          </div>
                          <div className="profile-viewer__analysis-value">
                            {formatMlcbAmount(entry?.total_payable_amount)}
                          </div>
                        </div>
                      </div>

                      {/* Months table */}
                      <div style={{ marginTop: 14 }}>
                        <div
                          style={{
                            fontSize: 12,
                            fontWeight: 700,
                            opacity: 0.8,
                            marginBottom: 8,
                          }}
                        >
                          Payment Status (Monthly)
                        </div>

                        {monthsArr.length === 0 ? (
                          <div
                            style={{
                              padding: "12px",
                              fontSize: 12,
                              opacity: 0.7,
                            }}
                          >
                            No monthly status found.
                          </div>
                        ) : (
                          <div
                            style={{
                              padding: "10px 12px",
                              overflowX: "auto",
                            }}
                          >
                            <div
                              style={{
                                minWidth: isMobile ? 520 : 720, // lets it scroll horizontally on mobile
                              }}
                            >
                              {/* Row 1: Months (left -> right) */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: `repeat(${monthsArr.length}, minmax(70px, 1fr))`,
                                  gap: 8,
                                  fontSize: 11,
                                  fontWeight: 700,
                                  opacity: 0.85,
                                }}
                              >
                                {monthsArr.map((m, i) => (
                                  <div
                                    key={`mth-${m.monthKey}-${i}`}
                                    style={{
                                      textAlign: "center",
                                      padding: "6px 4px",
                                      borderRadius: 10,
                                      background: "rgba(0,0,0,0.03)",
                                      border: "1px solid rgba(0,0,0,0.06)",
                                    }}
                                  >
                                    {formatMonthKeyShort(m.monthKey)}
                                  </div>
                                ))}
                              </div>

                              {/* Row 2: Status pills (under each month) */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: `repeat(${monthsArr.length}, minmax(70px, 1fr))`,
                                  gap: 8,
                                  marginTop: 8,
                                }}
                              >
                                {monthsArr.map((m, i) => {
                                  const status = (m.status || "-")
                                    .toString()
                                    .trim()
                                    .toUpperCase();

                                  const pillStyle =
                                    status === "OK"
                                      ? {
                                          background:
                                            "rgba(46, 204, 113, 0.14)",
                                          border:
                                            "1px solid rgba(46, 204, 113, 0.35)",
                                          color: "rgba(20, 120, 60, 1)",
                                        }
                                      : status === "-"
                                        ? {
                                            background: "rgba(0,0,0,0.04)",
                                            border:
                                              "1px solid rgba(0,0,0,0.08)",
                                            color: "rgba(0,0,0,0.55)",
                                          }
                                        : {
                                            background:
                                              "rgba(241, 196, 15, 0.16)",
                                            border:
                                              "1px solid rgba(241, 196, 15, 0.35)",
                                            color: "rgba(140, 110, 0, 1)",
                                          };

                                  return (
                                    <div
                                      key={`sts-${m.monthKey}-${i}`}
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        padding: "6px 0",
                                      }}
                                    >
                                      <span
                                        style={{
                                          padding: "5px 12px",
                                          borderRadius: 999,
                                          fontSize: 11,
                                          fontWeight: 800,
                                          whiteSpace: "nowrap",
                                          ...pillStyle,
                                        }}
                                      >
                                        {status}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          ) : viewingTab === sccbReportTabIndex ? (
            <SccbPdfViewer
              data={sccbReportData}
              reportType={sccbReportType}
              brand={sccbBrand}
              excludeColumns={sccbExcludeColumns}
              filename="SmartLend_SCCB_Report.pdf"
            />
          ) : viewingTab === borrowerReportTabIndex && !loading ? (
            personalOnly ? (
              <div style={{ overflow: "hidden", borderRadius: "15px" }}>
                <PDFViewer style={{ width: "100%", height: "80vh" }}>
                  <Document>
                    <Page size="A4">
                      {renderPdfHeader("")}
                      {notes || platform_notes || loan_remark ? (
                        <View style={{ marginTop: 10, paddingHorizontal: 28 }}>
                          <View
                            style={{
                              backgroundColor: "#e3e6f6",
                              alignItems: "center",
                              padding: 4,
                              borderTopLeftRadius: 7,
                              borderTopRightRadius: 7,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: reportTitleFontSize,
                                fontFamily: "Poppins",
                                fontWeight: 700,
                              }}
                            >
                              Borrower Profile Notes
                            </Text>
                          </View>
                          <View
                            style={{
                              padding: 6,
                              borderColor: "#e3e6f6",
                              borderLeftWidth: 2,
                              borderRightWidth: 2,
                              borderBottomWidth: 2,
                            }}
                          >
                            {loan_remark ? (
                              <View>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                    marginTop: 6,
                                  }}
                                >
                                  Loan Remarks
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  {loan_remark}
                                </Text>
                              </View>
                            ) : null}
                            {notes ? (
                              <View>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                    marginTop: 6,
                                  }}
                                >
                                  Borrower Note
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  {notes}
                                </Text>
                              </View>
                            ) : null}
                            {platform_notes ? (
                              <View>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                    marginTop: 6,
                                  }}
                                >
                                  Platform Notes
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  {platform_notes}
                                </Text>
                              </View>
                            ) : null}
                          </View>
                        </View>
                      ) : null}
                      <View style={{ marginTop: 10, paddingHorizontal: 28 }}>
                        <View
                          style={{
                            backgroundColor: reportTheme.headerBlue,
                            alignItems: "center",
                            padding: 8,
                            borderTopLeftRadius: 7,
                            borderTopRightRadius: 7,
                          }}
                        >
                          <Text
                            style={{
                              fontSize: reportTitleFontSize,
                              fontFamily: "Poppins",
                              fontWeight: 700,
                              color: "#ffffff",
                            }}
                          >
                            Personal Borrower Report
                          </Text>
                        </View>
                        <View
                          style={{
                            borderColor: reportTheme.borderBlue,
                            borderWidth: 1,
                          }}
                        >
                          {personalReportEntries.map((entry, entryIndex) => (
                            <View
                              key={entry.label}
                              style={{
                                flexDirection: "row",
                                backgroundColor:
                                  entryIndex % 2 === 0
                                    ? reportTheme.rowEven
                                    : reportTheme.rowOdd,
                                borderBottomWidth: 1,
                                borderBottomColor: reportTheme.borderBlue,
                              }}
                            >
                              <View
                                style={{
                                  width: "40%",
                                  paddingVertical: 6,
                                  paddingHorizontal: 8,
                                  borderRightWidth: 1,
                                  borderRightColor: reportTheme.borderBlue,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                    color: reportTheme.labelColor,
                                  }}
                                >
                                  {entry.label}
                                </Text>
                              </View>
                              <View
                                style={{
                                  width: "60%",
                                  paddingVertical: 6,
                                  paddingHorizontal: 8,
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                  }}
                                >
                                  {entry.value}
                                </Text>
                              </View>
                            </View>
                          ))}
                        </View>
                      </View>
                      <View style={{ marginTop: 8, paddingHorizontal: 28 }}>
                        {renderPersonalMyInfoSectionsPdf()}
                      </View>
                    </Page>
                    <Page size="A4">
                      {renderPdfHeader("")}
                      <View style={{ paddingHorizontal: 28 }}>
                        {renderPersonalCbsReport()}
                        {renderSccbBorrowerSections()}
                      </View>
                    </Page>
                    {bankAnalysisContext?.enabled &&
                    bankAnalysisState.statements.length > 0 ? (
                      <Page size="A4">
                        {renderPdfHeader("Customer Document Analysis")}
                        {renderBankAnalysisPdf()}
                      </Page>
                    ) : null}
                    {mlcbAnalysisContext?.enabled &&
                    mlcbAnalysisState.entries.length > 0 ? (
                      <Page size="A4">
                        {renderPdfHeader("MLCB Analysis")}
                        {renderMlcbAnalysisPdf()}
                      </Page>
                    ) : null}
                  </Document>
                </PDFViewer>
              </div>
            ) : (
              <div style={{ overflow: "hidden", borderRadius: "15px" }}>
                <PDFViewer style={{ width: "100%", height: "80vh" }}>
                  <Document>
                    <Page size="A4">
                      {/**Letterhead section */}
                      <View
                        style={{
                          paddingVertical: 15,
                        }}
                      >
                        <View
                          style={{
                            paddingHorizontal: 40,
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            gap: 10,
                            // borderBottom: 1,
                            // borderBottomColor: "grey",
                            paddingBottom: 10,
                          }}
                        >
                          <Image
                            source={logo}
                            style={{ width: 80, objectFit: "contain" }}
                          />
                          <View>
                            <Text
                              style={{
                                fontSize: 18,
                                fontFamily: "Poppins",
                                fontWeight: 700,
                              }}
                            >
                              SmartLend Financial Pte. Ltd.
                            </Text>
                            <View
                              style={{
                                flexDirection: "row",
                                gap: 4,
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: -3,
                              }}
                            >
                              <Text style={{ fontSize: reportBodyFontSize }}>
                                UEN: 202327568G
                              </Text>
                              <Text style={{ fontSize: reportBodyFontSize }}>
                                Tel: +65 87853373
                              </Text>
                              <Text style={{ fontSize: reportBodyFontSize }}>
                                Email: support@smart-lend.com
                              </Text>
                            </View>
                          </View>
                        </View>
                        <View
                          style={{
                            backgroundColor: "lightgrey",
                            height: 2,
                            width: "100%",
                            marginTop: 20,
                          }}
                        />
                        <View
                          style={{
                            backgroundColor: "#6d5cf6",
                            height: 4,
                            width: "76%",
                            marginTop: -3,
                            marginLeft: "12%",
                            marginBottom: 15,
                          }}
                        />
                        {notes || platform_notes || loan_remark ? (
                          <View
                            style={{ marginTop: 15, paddingHorizontal: 40 }}
                          >
                            <View
                              style={{
                                backgroundColor: reportTheme.headerBlue,
                                alignItems: "center",
                                padding: 6,
                                borderTopLeftRadius: 7,
                                borderTopRightRadius: 7,
                              }}
                            >
                              <Text
                                style={{
                                  fontSize: reportTitleFontSize,
                                  fontFamily: "Poppins",
                                  fontWeight: 700,
                                  color: "#ffffff",
                                }}
                              >
                                Borrower Profile Notes
                              </Text>
                            </View>
                            <View
                              style={{
                                padding: 8,
                                borderColor: reportTheme.borderBlue,
                                borderLeftWidth: 1,
                                borderRightWidth: 1,
                                borderBottomWidth: 1,
                              }}
                            >
                              {loan_remark ? (
                                <View>
                                  <Text
                                    style={{
                                      fontSize: reportBodyFontSize,
                                      fontFamily: "Poppins",
                                      fontWeight: 700,
                                      marginTop: 10,
                                    }}
                                  >
                                    Platform Remarks:
                                  </Text>
                                  <Text
                                    style={{
                                      fontSize: reportBodyFontSize,
                                      width: "90%",
                                    }}
                                  >
                                    {JSON.parse(loan_remark)?.message}
                                  </Text>
                                </View>
                              ) : null}
                              {platform_notes && platform_notes !== "" ? (
                                <View>
                                  <Text
                                    style={{
                                      fontSize: reportBodyFontSize,
                                      fontFamily: "Poppins",
                                      fontWeight: 700,
                                      marginTop: loan_remark ? 10 : 0,
                                    }}
                                  >
                                    Platform Notes:
                                  </Text>
                                  <Text
                                    style={{
                                      fontSize: reportBodyFontSize,
                                      width: "90%",
                                    }}
                                  >
                                    {platform_notes}
                                  </Text>{" "}
                                </View>
                              ) : null}
                              {notes && notes !== "" ? (
                                <View>
                                  <Text
                                    style={{
                                      fontSize: reportBodyFontSize,
                                      fontFamily: "Poppins",
                                      fontWeight: 700,
                                      marginTop:
                                        platform_notes && platform_notes !== ""
                                          ? 10
                                          : 0,
                                    }}
                                  >
                                    Borrower's Notes:
                                  </Text>
                                  <Text
                                    style={{
                                      fontSize: reportBodyFontSize,
                                      width: "90%",
                                    }}
                                  >
                                    {notes}
                                  </Text>
                                </View>
                              ) : null}
                            </View>
                          </View>
                        ) : null}
                        <View style={{ marginTop: 15, paddingHorizontal: 40 }}>
                          <View
                            style={{
                              backgroundColor: reportTheme.headerBlue,
                              alignItems: "center",
                              padding: 6,
                              borderTopLeftRadius: 7,
                              borderTopRightRadius: 7,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: reportTitleFontSize,
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                color: "#ffffff",
                              }}
                            >
                              Company Profile
                            </Text>
                          </View>
                          <View
                            style={{
                              flexDirection: "row",
                              padding: 8,
                              borderColor: reportTheme.borderBlue,
                              borderLeftWidth: 1,
                              borderRightWidth: 1,
                              borderBottomWidth: 1,
                            }}
                          >
                            <View style={{ width: "50%" }}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Entity Name:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "65%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["basic-profile"][
                                      "entity-name"
                                    ]?.value
                                  }
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  UEN:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "65%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["basic-profile"]?.uen
                                      ?.value
                                  }
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Registration Date:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "65%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["basic-profile"]?.[
                                      "registration-date"
                                    ]?.value
                                  }
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Primary Activity:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "65%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["basic-profile"][
                                      "primary-activity"
                                    ]?.desc
                                  }
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Ownership:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "65%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["basic-profile"]?.[
                                      "ownership"
                                    ]?.desc
                                  }
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Entity Status:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "65%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["basic-profile"]?.[
                                      "entity-status"
                                    ]?.value
                                  }
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Business Constitution:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "65%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["basic-profile"]?.[
                                      "company-type"
                                    ]?.desc
                                  }
                                </Text>
                              </View>
                              <View style={{ flexDirection: "row", gap: 10 }}>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Business Verification By Smartlend:
                                </Text>
                                <Text style={{ fontSize: reportBodyFontSize }}>
                                  {badgeVerified ? "Verified" : "Un-verified"}
                                </Text>
                              </View>
                            </View>
                            <View style={{ width: "50%" }}>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  ACRA Address:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "60%",
                                  }}
                                >
                                  {singpassData?.entity?.addresses[
                                    "addresses-list"
                                  ][0]
                                    ? (singpassData?.entity?.addresses?.[
                                        "addresses-list"
                                      ]?.[0]?.unit?.value !== undefined
                                        ? `Unit ${singpassData?.entity?.addresses?.["addresses-list"]?.[0]?.unit?.value}, `
                                        : "") +
                                      (singpassData?.entity?.addresses?.[
                                        "addresses-list"
                                      ]?.[0]?.floor?.value !== undefined
                                        ? `Floor ${singpassData?.entity?.addresses?.["addresses-list"]?.[0]?.floor?.value}, `
                                        : "") +
                                      (singpassData?.entity?.addresses?.[
                                        "addresses-list"
                                      ]?.[0]?.block?.value !== undefined
                                        ? `Block ${singpassData?.entity?.addresses?.["addresses-list"]?.[0]?.block?.value}, `
                                        : "") +
                                      (singpassData?.entity?.addresses?.[
                                        "addresses-list"
                                      ]?.[0]?.street?.value !== undefined
                                        ? `${singpassData?.entity?.addresses?.["addresses-list"]?.[0]?.street?.value}, `
                                        : "") +
                                      (singpassData?.entity?.addresses?.[
                                        "addresses-list"
                                      ]?.[0]?.postal?.value !== undefined
                                        ? `${singpassData?.entity?.addresses?.["addresses-list"]?.[0]?.postal?.value}, `
                                        : "") +
                                      (singpassData?.entity?.addresses?.[
                                        "addresses-list"
                                      ]?.[0]?.country?.desc !== undefined
                                        ? `${singpassData?.entity?.addresses?.["addresses-list"]?.[0]?.country?.desc}.`
                                        : "")
                                    : ""}
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Capital Type:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "60%",
                                  }}
                                >
                                  {
                                    singpassData?.entity?.["capitals"]?.[
                                      "capitals-list"
                                    ]?.[0]?.["capital-type"]?.desc
                                  }
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Paid Up Capital:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "60%",
                                  }}
                                >
                                  {singpassData?.entity?.["capitals"]?.[
                                    "capitals-list"
                                  ]?.[0]?.[
                                    "paid-up-capital-amount"
                                  ]?.value?.toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "SGD",
                                  })}
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Share Allocated Amount:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "60%",
                                  }}
                                >
                                  {singpassData?.entity?.["capitals"]?.[
                                    "capitals-list"
                                  ]?.[0]?.[
                                    "share-allotted-amount"
                                  ]?.value?.toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "SGD",
                                  })}
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Issued Capital Amount:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "60%",
                                  }}
                                >
                                  {singpassData?.entity?.["capitals"]?.[
                                    "capitals-list"
                                  ]?.[0]?.[
                                    "issued-capital-amount"
                                  ]?.value?.toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "SGD",
                                  })}
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Estimated Annual Rev.:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "60%",
                                  }}
                                >
                                  {backupContactDetails?.estimated_annual_revenue
                                    ? backupContactDetails?.estimated_annual_revenue ===
                                      "under 200k"
                                      ? "Under SGD 200,000"
                                      : backupContactDetails?.estimated_annual_revenue ===
                                          "between 200 and 599"
                                        ? "Between SGD 200,000 - 599,999"
                                        : backupContactDetails?.estimated_annual_revenue ===
                                            "between 600 and 2"
                                          ? "Between SGD 600,000 - 1,999,999"
                                          : "Exceeds SGD 2,000,000"
                                    : "Under SGD 200,000"}
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Keyman Email:
                                </Text>
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    width: "60%",
                                  }}
                                >
                                  {getPersonData(getShareholderAddress(keyman)?.[0])
                                    ?.email?.value !== undefined &&
                                  getPersonData(getShareholderAddress(keyman)?.[0])
                                    ?.email?.value !== "" &&
                                  getPersonData(getShareholderAddress(keyman)?.[0])
                                    ?.email?.value !== null
                                    ? getDisplayEmail(
                                        getPersonData(getShareholderAddress(keyman)?.[0])?.email?.value,
                                      )
                                    : backupContactDetails
                                      ? getDisplayEmail(
                                          backupContactDetails.email,
                                        )
                                      : "N/A"}
                                </Text>
                              </View>
                              <View
                                style={{
                                  flexDirection: "row",
                                  gap: 10,
                                  justifyContent: "space-between",
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: reportBodyFontSize,
                                    fontFamily: "Poppins",
                                    fontWeight: 700,
                                  }}
                                >
                                  Keyman Mobile:
                                </Text>
                                <View
                                  style={{
                                    flexDirection: "row",
                                    width: "60%",
                                    gap: 10,
                                  }}
                                >
                                  <View>
                                    <Text
                                      style={{ fontSize: reportBodyFontSize }}
                                    >
                                      {getPersonData(getShareholderAddress(keyman)?.[0])?.mobileno?.nbr?.value !==
                                        undefined &&
                                      getPersonData(getShareholderAddress(keyman)?.[0])
                                        ?.mobileno?.nbr?.value !== "" &&
                                      getPersonData(getShareholderAddress(keyman)?.[0])
                                        ?.mobileno?.nbr?.value !== null
                                        ? getDisplayMobile(
                                            getPersonData(getShareholderAddress(keyman)?.[0])?.mobileno?.prefix
                                              ?.value +
                                              getPersonData(getShareholderAddress(keyman)?.[0])?.mobileno?.areacode
                                                ?.value +
                                              "-" +
                                              getPersonData(getShareholderAddress(keyman)?.[0])?.mobileno?.nbr?.value,
                                          )
                                        : backupContactDetails
                                          ? getDisplayMobile(
                                              `+${backupContactDetails.mobile_no} `,
                                            )
                                          : "N/A"}
                                    </Text>
                                  </View>
                                  <View
                                    style={{
                                      backgroundColor: "#2f9151",
                                      padding: "2px 5px",
                                      borderRadius: "3px",
                                    }}
                                  >
                                    <Text
                                      style={{
                                        color: "white",
                                        fontSize: reportBodyFontSize,
                                      }}
                                    >
                                      Verified
                                    </Text>
                                  </View>
                                </View>
                              </View>
                            </View>
                          </View>
                        </View>
                        <View style={{ marginTop: 15, paddingHorizontal: 40 }}>
                          <View
                            style={{
                              backgroundColor: reportTheme.headerBlue,
                              alignItems: "center",
                              padding: 6,
                              borderTopLeftRadius: 7,
                              borderTopRightRadius: 7,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: reportTitleFontSize,
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                color: "#ffffff",
                              }}
                            >
                              Financial Highlight
                            </Text>
                          </View>
                          <View
                            style={{
                              borderColor: reportTheme.borderBlue,
                              borderLeftWidth: 1,
                              borderRightWidth: 1,
                              borderBottomWidth: 1,
                              width: "100%",
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                width: "100%",
                                backgroundColor: reportTheme.headerBlue,
                                opacity: 0.7,
                                padding: 4,
                                color: "#ffffff",
                                fontWeight: 700,
                              }}
                            >
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text
                                  style={{ color: "#ffffff", fontWeight: 700 }}
                                >
                                  Revenue
                                </Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text
                                  style={{ color: "#ffffff", fontWeight: 700 }}
                                >
                                  Profit pre-tax
                                </Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text
                                  style={{ color: "#ffffff", fontWeight: 700 }}
                                >
                                  Profit post-tax
                                </Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text
                                  style={{ color: "#ffffff", fontWeight: 700 }}
                                >
                                  Start date
                                </Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text
                                  style={{ color: "#ffffff", fontWeight: 700 }}
                                >
                                  End date
                                </Text>
                              </View>
                            </View>
                            {singpassData?.entity?.financials?.highlights?.map(
                              (data, index) => (
                                <View
                                  key={index}
                                  style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    backgroundColor:
                                      index % 2
                                        ? reportTheme.rowOdd
                                        : "transparent",
                                    padding: 4,
                                  }}
                                >
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {data?.[
                                        "company-revenue"
                                      ]?.value?.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "SGD",
                                      })}
                                    </Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {data?.[
                                        "company-profit-loss-before-tax"
                                      ]?.value?.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "SGD",
                                      })}
                                    </Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {data?.[
                                        "company-profit-loss-after-tax"
                                      ]?.value?.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "SGD",
                                      })}
                                    </Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {
                                        data?.["current-period-start-date"]
                                          ?.value
                                      }
                                    </Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {data?.["current-period-end-date"]?.value}
                                    </Text>
                                  </View>
                                </View>
                              ),
                            )}
                          </View>
                        </View>
                        <View style={{ marginTop: 15, paddingHorizontal: 40 }}>
                          <View
                            style={{
                              backgroundColor: reportTheme.headerBlue,
                              alignItems: "center",
                              padding: 6,
                              borderTopLeftRadius: 7,
                              borderTopRightRadius: 7,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: reportTitleFontSize,
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                color: "#ffffff",
                              }}
                            >
                              Grants
                            </Text>
                          </View>
                          <View
                            style={{
                              borderColor: reportTheme.borderBlue,
                              borderLeftWidth: 1,
                              borderRightWidth: 1,
                              borderBottomWidth: 1,
                              width: "100%",
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                width: "100%",
                                backgroundColor: reportTheme.headerBlue,
                                opacity: 0.7,
                                padding: 4,
                                color: "#ffffff",
                                fontWeight: 700,
                                gap: 10,
                              }}
                            >
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Category</Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Functional Area</Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Grant Type</Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Grant Status</Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Approved Amount</Text>
                              </View>
                            </View>
                            {singpassData?.entity?.grants?.["grants-list"]?.map(
                              (data, index) => (
                                <View
                                  key={index}
                                  style={{
                                    flexDirection: "row",
                                    width: "100%",
                                    backgroundColor:
                                      index % 2
                                        ? reportTheme.rowOdd
                                        : "transparent",
                                    padding: 4,
                                    gap: 10,
                                  }}
                                >
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {data?.["development-category"]?.desc}
                                    </Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {data?.["functional-area"]?.desc}
                                    </Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>{data?.["grant-type"]?.desc}</Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>{data?.["grant-status"]?.desc}</Text>
                                  </View>
                                  <View
                                    style={{
                                      width: "19%",
                                      fontSize: reportBodyFontSize,
                                    }}
                                  >
                                    <Text>
                                      {data?.[
                                        "approved-amount"
                                      ]?.value?.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "SGD",
                                      })}
                                    </Text>
                                  </View>
                                </View>
                              ),
                            )}
                          </View>
                        </View>
                        <View style={{ marginTop: 15, paddingHorizontal: 40 }}>
                          <View
                            style={{
                              backgroundColor: reportTheme.headerBlue,
                              alignItems: "center",
                              padding: 6,
                              borderTopLeftRadius: 7,
                              borderTopRightRadius: 7,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: reportTitleFontSize,
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                color: "#ffffff",
                              }}
                            >
                              Officer(S) / Owners
                            </Text>
                          </View>
                          <View
                            style={{
                              borderColor: reportTheme.borderBlue,
                              borderLeftWidth: 1,
                              borderRightWidth: 1,
                              borderBottomWidth: 1,
                              width: "100%",
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                width: "100%",
                                backgroundColor: reportTheme.headerBlue,
                                opacity: 0.7,
                                padding: 4,
                                color: "#ffffff",
                                fontWeight: 700,
                                gap: 10,
                              }}
                            >
                              <View
                                style={{
                                  width: "25%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Officer Name</Text>
                              </View>
                              <View
                                style={{
                                  width: "13%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Identity No.</Text>
                              </View>
                              <View
                                style={{
                                  width: "13%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Position</Text>
                              </View>
                              <View
                                style={{
                                  width: "13%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Appointment Date</Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Nationality</Text>
                              </View>
                            </View>
                            {singpassData?.entity?.appointments?.[
                              "appointments-list"
                            ]?.map((data, index) => (
                              <View
                                key={index}
                                style={{
                                  flexDirection: "row",
                                  width: "100%",
                                  backgroundColor:
                                    index % 2
                                      ? reportTheme.rowOdd
                                      : "transparent",
                                  padding: 4,
                                  gap: 10,
                                }}
                              >
                                <View
                                  style={{
                                    width: "25%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {
                                      data?.["person-reference"]?.[
                                        "person-name"
                                      ]?.value
                                    }
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "13%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {
                                      data?.["person-reference"]?.["idno"]
                                        ?.value
                                    }
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "13%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>{data?.["position"]?.desc}</Text>
                                </View>
                                <View
                                  style={{
                                    width: "13%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {data?.["appointment-date"]?.value}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "19%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {
                                      data?.["person-reference"]?.[
                                        "nationality"
                                      ]?.desc
                                    }
                                  </Text>
                                </View>
                              </View>
                            ))}
                          </View>
                        </View>
                        <View style={{ marginTop: 15, paddingHorizontal: 40 }}>
                          <View
                            style={{
                              backgroundColor: reportTheme.headerBlue,
                              alignItems: "center",
                              padding: 6,
                              borderTopLeftRadius: 7,
                              borderTopRightRadius: 7,
                            }}
                          >
                            <Text
                              style={{
                                fontSize: reportTitleFontSize,
                                fontFamily: "Poppins",
                                fontWeight: 700,
                                color: "#ffffff",
                              }}
                            >
                              Shareholders
                            </Text>
                          </View>
                          <View
                            style={{
                              borderColor: reportTheme.borderBlue,
                              borderLeftWidth: 1,
                              borderRightWidth: 1,
                              borderBottomWidth: 1,
                              width: "100%",
                            }}
                          >
                            <View
                              style={{
                                flexDirection: "row",
                                width: "100%",
                                backgroundColor: reportTheme.headerBlue,
                                opacity: 0.7,
                                padding: 4,
                                color: "#ffffff",
                                fontWeight: 700,
                                gap: 10,
                              }}
                            >
                              <View
                                style={{
                                  width: "25%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Shareholder Name / Address</Text>
                              </View>
                              <View
                                style={{
                                  width: "13%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Identity No.</Text>
                              </View>
                              <View
                                style={{
                                  width: "18%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Share Type</Text>
                              </View>
                              <View
                                style={{
                                  width: "13%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>No of Share</Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Nationality</Text>
                              </View>
                              <View
                                style={{
                                  width: "15%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Date of birth</Text>
                              </View>
                              <View
                                style={{
                                  width: "19%",
                                  fontSize: reportBodyFontSize,
                                  fontFamily: "Poppins",
                                }}
                              >
                                <Text>Corppass Contact</Text>
                              </View>
                            </View>
                            {singpassData?.entity?.shareholders?.[
                              "shareholders-list"
                            ]?.map((data, index) => (
                              <View
                                key={index}
                                style={{
                                  flexDirection: "row",
                                  width: "100%",
                                  backgroundColor:
                                    index % 2
                                      ? reportTheme.rowOdd
                                      : "transparent",
                                  padding: 4,
                                  gap: 10,
                                }}
                              >
                                <View
                                  style={{
                                    width: "25%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {data?.["person-reference"]?.["person-name"]
                                      ?.value
                                      ? data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value +
                                        " (" +
                                        getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.sex?.code +
                                        ")"
                                      : data?.["entity-reference"]?.[
                                          "entity-name"
                                        ]?.value + " (Corporate)"}
                                  </Text>
                                  <Text>
                                    {getPersonData(getShareholderAddress(
                                      data?.["person-reference"]?.[
                                        "person-name"
                                      ]?.value,
                                    )?.[0])?.regadd
                                      ? (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.unit?.value !==
                                        null
                                          ? `Unit ${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.unit
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.floor?.value !==
                                        null
                                          ? `Floor ${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.floor
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.block?.value !==
                                        null
                                          ? `Block ${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.block
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.street
                                          ?.value !== null
                                          ? `${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.street
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.postal
                                          ?.value !== null
                                          ? `${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.postal
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.country
                                          ?.desc !== null
                                          ? `${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.country
                                                ?.desc
                                            }.`
                                          : "")
                                      : ""}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "13%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {data?.["person-reference"]?.["idno"]?.value
                                      ? data?.["person-reference"]?.["idno"]
                                          ?.value
                                      : data?.["entity-reference"]?.["uen"]
                                          ?.value + " (UEN)"}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "18%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>{data?.["share-type"]?.desc}</Text>
                                </View>
                                <View
                                  style={{
                                    width: "13%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>{data?.["allocation"]?.value}</Text>
                                </View>
                                <View
                                  style={{
                                    width: "19%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {
                                      data?.["person-reference"]?.[
                                        "nationality"
                                      ]?.desc
                                    }
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "15%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {
                                      getPersonData(getShareholderAddress(
                                        data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value,
                                      )?.[0])?.dob?.value
                                    }
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "19%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {getDisplayEmail(
                                      getPersonData(getShareholderAddress(
                                        data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value,
                                      )?.[0])?.email?.value,
                                    )}
                                  </Text>
                                  <Text>
                                    {getDisplayMobile(
                                      getPersonData(getShareholderAddress(
                                        data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value,
                                      )?.[0])?.mobileno?.nbr?.value,
                                    )}
                                  </Text>
                                </View>
                              </View>
                            ))}
                            {singpassData?.entity?.shareholders?.[
                              "appointments-list"
                            ]?.map((data, index) => (
                              <View
                                key={index}
                                style={{
                                  flexDirection: "row",
                                  width: "100%",
                                  backgroundColor:
                                    index % 2
                                      ? reportTheme.rowOdd
                                      : "transparent",
                                  padding: 4,
                                  gap: 10,
                                }}
                              >
                                <View
                                  style={{
                                    width: "25%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {data?.["person-reference"]?.["person-name"]
                                      ?.value
                                      ? data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value +
                                        " (" +
                                        getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.sex?.code +
                                        ")"
                                      : data?.["entity-reference"]?.[
                                          "entity-name"
                                        ]?.value + " (Corporate)"}
                                  </Text>
                                  <Text>
                                    {getPersonData(getShareholderAddress(
                                      data?.["person-reference"]?.[
                                        "person-name"
                                      ]?.value,
                                    )?.[0])?.regadd
                                      ? (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.unit?.value !==
                                        null
                                          ? `Unit ${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.unit
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.floor?.value !==
                                        null
                                          ? `Floor ${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.floor
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.block?.value !==
                                        null
                                          ? `Block ${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.block
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.street
                                          ?.value !== null
                                          ? `${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.street
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.postal
                                          ?.value !== null
                                          ? `${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.postal
                                                ?.value
                                            }, `
                                          : "") +
                                        (getPersonData(getShareholderAddress(
                                          data?.["person-reference"]?.[
                                            "person-name"
                                          ]?.value,
                                        )?.[0])?.regadd?.country
                                          ?.desc !== null
                                          ? `${
                                              getPersonData(getShareholderAddress(
                                                data?.["person-reference"]?.[
                                                  "person-name"
                                                ]?.value,
                                              )?.[0])?.regadd?.country
                                                ?.desc
                                            }.`
                                          : "")
                                      : ""}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "13%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {data?.["person-reference"]?.["idno"]?.value
                                      ? data?.["person-reference"]?.["idno"]
                                          ?.value
                                      : data?.["entity-reference"]?.["uen"]
                                          ?.value + " (UEN)"}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "18%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>{data?.["share-type"]?.desc}</Text>
                                </View>
                                <View
                                  style={{
                                    width: "13%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>{data?.["allocation"]?.value}</Text>
                                </View>
                                <View
                                  style={{
                                    width: "19%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {
                                      data?.["person-reference"]?.[
                                        "nationality"
                                      ]?.desc
                                    }
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "15%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {
                                      getPersonData(getShareholderAddress(
                                        data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value,
                                      )?.[0])?.dob?.value
                                    }
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    width: "19%",
                                    fontSize: reportBodyFontSize,
                                  }}
                                >
                                  <Text>
                                    {getDisplayEmail(
                                      getPersonData(getShareholderAddress(
                                        data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value,
                                      )?.[0])?.email?.value,
                                    )}
                                  </Text>
                                  <Text>
                                    {getDisplayMobile(
                                      getPersonData(getShareholderAddress(
                                        data?.["person-reference"]?.[
                                          "person-name"
                                        ]?.value,
                                      )?.[0])?.mobileno?.nbr?.value,
                                    )}
                                  </Text>
                                </View>
                              </View>
                            ))}
                          </View>
                        </View>
                      </View>
                      <View></View>
                    </Page>
                    {combinedSingpassData
                      ? filteredCombined?.map((data, index) => (
                          <Page key={index} size="A4">
                            {/**Letterhead section */}
                            <View
                              style={{
                                paddingVertical: 15,
                              }}
                            >
                              <View
                                style={{
                                  marginTop: 15,
                                  paddingHorizontal: 40,
                                }}
                              >
                                <View
                                  style={{
                                    backgroundColor: reportTheme.headerBlue,
                                    alignItems: "center",
                                    padding: 6,
                                    borderTopLeftRadius: 7,
                                    borderTopRightRadius: 7,
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: reportTitleFontSize,
                                      fontFamily: "Poppins",
                                      fontWeight: 700,
                                      color: "#ffffff",
                                    }}
                                  >
                                    {getPersonData(data)?.name?.value +
                                      " | Personal Information"}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    flexDirection: "row",
                                    padding: 8,
                                    borderColor: reportTheme.borderBlue,
                                    borderLeftWidth: 1,
                                    borderRightWidth: 1,
                                  }}
                                >
                                  <View style={{ width: "50%" }}>
                                    <View
                                      style={{
                                        flexDirection: "row",
                                        gap: 10,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                        }}
                                      >
                                        Ownership of Private Residential
                                        Property:
                                      </Text>
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                        }}
                                      >
                                        {getPersonData(data)?.ownerprivate?.value
                                          ? "Yes"
                                          : "No"}
                                      </Text>
                                    </View>
                                    {getPersonData(data)?.hdbownership
                                      ? getPersonData(data)?.hdbownership?.length > 0
                                        ? getPersonData(data)?.hdbownership?.map(
                                            (hdb, index3) => {
                                              const personName =
                                                getPersonData(data)?.name?.value;
                                              const hdbSmartValuationResult =
                                                searchResults[personName]
                                                  ?.hdb_data?.[index3];
                                              console.log(
                                                "[ProfileViewer][SmartValuation] render HDB value",
                                                {
                                                  personName,
                                                  index: index3,
                                                  hdb,
                                                  personSearchResults:
                                                    searchResults[personName],
                                                  hdbSmartValuationResult,
                                                  displayValue:
                                                    hdbSmartValuationResult
                                                      ?.value,
                                                },
                                              );
                                              return (
                                              <View key={index3}>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                    marginTop: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    HDB {index3 + 1}
                                                  </Text>
                                                </View>

                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    HDB Ownership:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "65%",
                                                    }}
                                                  >
                                                    {hdb?.address
                                                      ? (hdb?.address?.unit
                                                          ?.value !== null
                                                          ? `Unit ${hdb?.address?.unit?.value}, `
                                                          : "") +
                                                        (hdb?.address?.floor
                                                          ?.value !== null
                                                          ? `Floor ${hdb?.address?.floor?.value}, `
                                                          : "") +
                                                        (hdb?.address?.block
                                                          ?.value !== null
                                                          ? `Block ${hdb?.address?.block?.value}, `
                                                          : "") +
                                                        (hdb?.address?.street
                                                          ?.value !== null
                                                          ? `${hdb?.address?.street?.value}, `
                                                          : "") +
                                                        (hdb?.address?.postal
                                                          ?.value !== null
                                                          ? `${hdb?.address?.postal?.value}, `
                                                          : "") +
                                                        (hdb?.address?.country
                                                          ?.desc !== null
                                                          ? `${hdb?.address?.country?.desc}.`
                                                          : "")
                                                      : ""}
                                                  </Text>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Property Valuation:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                    }}
                                                  >
                                                    {hdbSmartValuationResult?.value}
                                                  </Text>
                                                  <View
                                                    style={{
                                                      backgroundColor:
                                                        "#2f9151",
                                                      padding: "2px 5px",
                                                      borderRadius: "3px",
                                                    }}
                                                  >
                                                    <Text
                                                      style={{
                                                        color: "white",
                                                        fontSize:
                                                          reportBodyFontSize,
                                                      }}
                                                    >
                                                      SmartValuation
                                                    </Text>
                                                  </View>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Outstanding HDB Loan
                                                    Balance:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "30%",
                                                    }}
                                                  >
                                                    {hdb?.outstandingloanbalance?.value?.toLocaleString(
                                                      "en-US",
                                                      {
                                                        style: "currency",
                                                        currency: "SGD",
                                                      },
                                                    )}
                                                  </Text>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Type of HDB:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "65%",
                                                    }}
                                                  >
                                                    {hdb?.hdbtype?.desc}
                                                  </Text>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Monthly Loan Installment:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "65%",
                                                    }}
                                                  >
                                                    {hdb?.monthlyloaninstalment?.value?.toLocaleString(
                                                      "en-US",
                                                      {
                                                        style: "currency",
                                                        currency: "SGD",
                                                      },
                                                    )}
                                                  </Text>
                                                </View>
                                              </View>
                                              );
                                            },
                                          )
                                        : "No"
                                      : "No"}
                                    <View>
                                      {getPersonData(data)?.cpfhousingwithdrawal
                                        ?.withdrawaldetails?.length > 0
                                        ? getPersonData(data)?.cpfhousingwithdrawal?.withdrawaldetails.map(
                                            (cpf, index) => {
                                              const personName =
                                                getPersonData(data)?.name?.value;
                                              const cpfSmartValuationResult =
                                                searchResults[personName]
                                                  ?.cpf_data?.[index];
                                              console.log(
                                                "[ProfileViewer][SmartValuation] render CPF value",
                                                {
                                                  personName,
                                                  index,
                                                  cpf,
                                                  personSearchResults:
                                                    searchResults[personName],
                                                  cpfSmartValuationResult,
                                                  displayValue:
                                                    cpfSmartValuationResult
                                                      ?.value,
                                                },
                                              );
                                              return (
                                              <View
                                                style={{ marginTop: 10 }}
                                                key={index}
                                              >
                                                <Text
                                                  style={{
                                                    fontSize:
                                                      reportBodyFontSize,
                                                    fontFamily: "Poppins",
                                                    fontWeight: 700,
                                                  }}
                                                >
                                                  CPF Usage{" "}
                                                  {(cpf.address.unit?.value !==
                                                  undefined
                                                    ? `Unit ${cpf.address.unit?.value}, `
                                                    : "") +
                                                    (cpf.address.floor
                                                      ?.value !== undefined
                                                      ? `Floor ${cpf.address.floor?.value}, `
                                                      : "") +
                                                    (cpf.address.block
                                                      ?.value !== undefined
                                                      ? `Block ${cpf.address.block?.value}, `
                                                      : "") +
                                                    (cpf.address.street
                                                      ?.value !== undefined
                                                      ? `${cpf.address.street?.value}, `
                                                      : "") +
                                                    (cpf.address.postal
                                                      ?.value !== undefined
                                                      ? `${cpf.address.postal?.value}, `
                                                      : "") +
                                                    (cpf.address.country
                                                      ?.desc !== undefined
                                                      ? `${cpf.address.country?.desc}.`
                                                      : "")}
                                                  :
                                                </Text>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Property Valuation:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                    }}
                                                  >
                                                    {cpfSmartValuationResult?.value}
                                                  </Text>
                                                  <View
                                                    style={{
                                                      backgroundColor:
                                                        "#2f9151",
                                                      padding: "2px 5px",
                                                      borderRadius: "3px",
                                                    }}
                                                  >
                                                    <Text
                                                      style={{
                                                        color: "white",
                                                        fontSize:
                                                          reportBodyFontSize,
                                                      }}
                                                    >
                                                      SmartValuation
                                                    </Text>
                                                  </View>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Principal Withdrawal Amount:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "30%",
                                                    }}
                                                  >
                                                    {cpf?.principalwithdrawalamt?.value?.toLocaleString(
                                                      "en-US",
                                                      {
                                                        style: "currency",
                                                        currency: "SGD",
                                                      },
                                                    )}
                                                  </Text>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Accrued Interest Amount:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "30%",
                                                    }}
                                                  >
                                                    {cpf?.accruedinterestamt?.value?.toLocaleString(
                                                      "en-US",
                                                      {
                                                        style: "currency",
                                                        currency: "SGD",
                                                      },
                                                    )}
                                                  </Text>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Monthly Installment (CPF):
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "30%",
                                                    }}
                                                  >
                                                    {cpf?.monthlyinstalmentamt?.value?.toLocaleString(
                                                      "en-US",
                                                      {
                                                        style: "currency",
                                                        currency: "SGD",
                                                      },
                                                    )}
                                                  </Text>
                                                </View>
                                                <View
                                                  style={{
                                                    flexDirection: "row",
                                                    gap: 10,
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      fontFamily: "Poppins",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    Total Amount of CPF Allowed
                                                    For Property:
                                                  </Text>
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "30%",
                                                    }}
                                                  >
                                                    {cpf?.totalamountofcpfallowedforproperty?.value?.toLocaleString(
                                                      "en-US",
                                                      {
                                                        style: "currency",
                                                        currency: "SGD",
                                                      },
                                                    )}
                                                  </Text>
                                                </View>
                                              </View>
                                              );
                                            },
                                          )
                                        : "None"}
                                    </View>
                                  </View>
                                  <View style={{ width: "50%" }}>
                                    <View
                                      style={{
                                        flexDirection: "row",
                                        gap: 10,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                        }}
                                      >
                                        Contact:
                                      </Text>
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          width: "65%",
                                        }}
                                      >
                                        {getDisplayMobile(
                                          getPersonData(data)?.mobileno?.nbr?.value,
                                        )}
                                      </Text>
                                    </View>
                                    <View
                                      style={{
                                        flexDirection: "row",
                                        gap: 10,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                        }}
                                      >
                                        Email:
                                      </Text>
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          width: "65%",
                                        }}
                                      >
                                        {getDisplayEmail(
                                          getPersonData(data)?.email?.value,
                                        )}
                                      </Text>
                                    </View>
                                    <View
                                      style={{
                                        flexDirection: "row",
                                        gap: 10,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                        }}
                                      >
                                        Marital Status:
                                      </Text>
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          width: "65%",
                                        }}
                                      >
                                        {getPersonData(data)?.marital?.desc}
                                      </Text>
                                    </View>
                                    <View
                                      style={{
                                        flexDirection: "row",
                                        gap: 10,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                        }}
                                      >
                                        Vehicles:
                                      </Text>
                                      <Text
                                        style={{
                                          fontSize: reportBodyFontSize,
                                          width: "65%",
                                        }}
                                      >
                                        {getPersonData(data)?.vehicles?.length > 0
                                          ? getPersonData(data)?.vehicles?.map(
                                              (veh, index4) => (
                                                <Text
                                                  key={index4}
                                                  style={{
                                                    fontSize:
                                                      reportBodyFontSize,
                                                    width: "65%",
                                                  }}
                                                >
                                                  <Text
                                                    style={{
                                                      fontSize:
                                                        reportBodyFontSize,
                                                      width: "65%",
                                                    }}
                                                  >
                                                    {veh?.make?.value +
                                                      ": " +
                                                      veh?.model?.value}
                                                  </Text>
                                                </Text>
                                              ),
                                            )
                                          : "None"}
                                      </Text>
                                    </View>
                                  </View>
                                </View>
                                <View
                                  style={{
                                    padding: 8,
                                    borderColor: reportTheme.borderBlue,
                                    borderLeftWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                  }}
                                >
                                  <View>
                                    <Text
                                      style={{
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                        fontWeight: 700,
                                      }}
                                    >
                                      Disclaimer:
                                    </Text>
                                  </View>
                                  <View>
                                    <Text
                                      style={{ fontSize: reportBodyFontSize }}
                                    >
                                      The valuation is conducted by a reputable
                                      third-party valuation firm and is provided
                                      for reference and indicative purposes
                                      only. It should not be construed as a
                                      definitive or binding assessment of value.
                                    </Text>
                                  </View>
                                </View>
                              </View>
                              <View
                                style={{
                                  marginTop: 15,
                                  paddingHorizontal: 40,
                                }}
                              >
                                <View
                                  style={{
                                    backgroundColor: reportTheme.headerBlue,
                                    alignItems: "center",
                                    padding: 6,
                                    borderTopLeftRadius: 7,
                                    borderTopRightRadius: 7,
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: reportTitleFontSize,
                                      fontFamily: "Poppins",
                                      fontWeight: 700,
                                      color: "#ffffff",
                                    }}
                                  >
                                    {getPersonData(data)?.name?.value +
                                      " | Notice of Assessments"}
                                  </Text>
                                </View>
                                <View
                                  style={{
                                    borderColor: reportTheme.borderBlue,
                                    borderLeftWidth: 1,
                                    borderRightWidth: 1,
                                    borderBottomWidth: 1,
                                    width: "100%",
                                  }}
                                >
                                  <View
                                    style={{
                                      flexDirection: "row",
                                      width: "100%",
                                      backgroundColor: reportTheme.headerBlue,
                                      opacity: 0.7,
                                      padding: 4,
                                      gap: 10,
                                    }}
                                  >
                                    <View
                                      style={{
                                        width: "14%",
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      <Text>Year of Assesment</Text>
                                    </View>
                                    <View
                                      style={{
                                        width: "14%",
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      <Text>Amount</Text>
                                    </View>
                                    <View
                                      style={{
                                        width: "14%",
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      <Text>Employment</Text>
                                    </View>
                                    <View
                                      style={{
                                        width: "14%",
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      <Text>Interest</Text>
                                    </View>
                                    <View
                                      style={{
                                        width: "14%",
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      <Text>Rent</Text>
                                    </View>
                                    <View
                                      style={{
                                        width: "14%",
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      <Text>Trade</Text>
                                    </View>
                                    <View
                                      style={{
                                        width: "14%",
                                        fontSize: reportBodyFontSize,
                                        fontFamily: "Poppins",
                                      }}
                                    >
                                      <Text>Tax Clearance</Text>
                                    </View>
                                  </View>
                                  {getPersonData(data)?.noahistory?.noas?.map(
                                    (data2, index2) => (
                                      <View
                                        key={index2}
                                        style={{
                                          flexDirection: "row",
                                          width: "100%",
                                          backgroundColor:
                                            index2 % 2
                                              ? reportTheme.rowOdd
                                              : "transparent",
                                          padding: 4,
                                          gap: 10,
                                        }}
                                      >
                                        <View
                                          style={{
                                            width: "14%",
                                            fontSize: reportBodyFontSize,
                                          }}
                                        >
                                          <Text>
                                            {data2?.["yearofassessment"]?.value}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "14%",
                                            fontSize: reportBodyFontSize,
                                          }}
                                        >
                                          <Text>
                                            {data2?.[
                                              "amount"
                                            ]?.value?.toLocaleString("en-us", {
                                              style: "currency",
                                              currency: "SGD",
                                            })}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "14%",
                                            fontSize: reportBodyFontSize,
                                          }}
                                        >
                                          <Text>
                                            {data2?.[
                                              "employment"
                                            ]?.value?.toLocaleString("en-us", {
                                              style: "currency",
                                              currency: "SGD",
                                            })}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "14%",
                                            fontSize: reportBodyFontSize,
                                          }}
                                        >
                                          <Text>
                                            {data2?.[
                                              "interest"
                                            ]?.value?.toLocaleString("en-us", {
                                              style: "currency",
                                              currency: "SGD",
                                            })}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "14%",
                                            fontSize: reportBodyFontSize,
                                          }}
                                        >
                                          <Text>
                                            {data2?.[
                                              "rent"
                                            ]?.value?.toLocaleString("en-us", {
                                              style: "currency",
                                              currency: "SGD",
                                            })}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "14%",
                                            fontSize: reportBodyFontSize,
                                          }}
                                        >
                                          <Text>
                                            {data2?.[
                                              "trade"
                                            ]?.value?.toLocaleString("en-us", {
                                              style: "currency",
                                              currency: "SGD",
                                            })}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "14%",
                                            fontSize: reportBodyFontSize,
                                          }}
                                        >
                                          <Text>
                                            {data2?.["taxclearance"]?.value}
                                          </Text>
                                        </View>
                                      </View>
                                    ),
                                  )}
                                </View>
                              </View>
                              {allCBSData?.filter(
                                (dat2) =>
                                  dat2?.name === getPersonData(data)?.name?.value,
                              )?.[0] ? (
                                <>
                                  <View break>
                                    {renderPdfHeader(
                                      `${getPersonData(data)?.name?.value || "Borrower"} Credit Bureau Report`,
                                    )}
                                  </View>
                                  <View
                                    style={{
                                      marginTop: 15,
                                      paddingHorizontal: 40,
                                    }}
                                  >
                                    <View
                                      style={{
                                        backgroundColor: reportTheme.headerBlue,
                                        alignItems: "center",
                                        padding: 6,
                                        borderTopLeftRadius: 7,
                                        borderTopRightRadius: 7,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: reportTitleFontSize,
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                          color: "#ffffff",
                                        }}
                                      >
                                        {getPersonData(data)?.name?.value +
                                          " | Credit Bureau | Personal Commitement"}
                                      </Text>
                                    </View>
                                    <View
                                      style={{
                                        flexDirection: "row",
                                        padding: 8,
                                        borderColor: reportTheme.borderBlue,
                                        borderLeftWidth: 1,
                                        borderRightWidth: 1,
                                      }}
                                    >
                                      <View style={{ width: "50%" }}>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Secured Credit Limit:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {allCBSData
                                              ?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]
                                              ?.cbs_data?.SecuredCreditLimit?.toLocaleString(
                                                "en-US",
                                                {
                                                  style: "currency",
                                                  currency: "SGD",
                                                },
                                              )}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Credit Score:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {
                                              allCBSData?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]?.cbs_data?.CreditScore
                                            }
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Probability of Default:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {
                                              allCBSData?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]?.cbs_data
                                                ?.ProbabilityofDefault
                                            }
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Unsecured Credit Utilized:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {allCBSData
                                              ?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]
                                              ?.cbs_data?.UnsecuredCreditUtilized?.toLocaleString(
                                                "en-US",
                                                {
                                                  style: "currency",
                                                  currency: "SGD",
                                                },
                                              )}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Unsecured Credit Utilization in
                                            percentage:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {(Number(
                                              allCBSData?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]?.cbs_data
                                                ?.UnsecuredCreditUtilizationinpercentage,
                                            ) || 0) + "%"}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Default Record:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {allCBSData?.filter(
                                              (dat2) =>
                                                dat2?.name ===
                                                getPersonData(data)?.name?.value,
                                            )?.[0]?.cbs_data?.defaults
                                              ? "True"
                                              : "N/A"}
                                          </Text>
                                        </View>
                                      </View>
                                      <View style={{ width: "50%" }}>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Unsecured Credit Limit:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {allCBSData
                                              ?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]
                                              ?.cbs_data?.UnsecuredCreditLimit?.toLocaleString(
                                                "en-US",
                                                {
                                                  style: "currency",
                                                  currency: "SGD",
                                                },
                                              )}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Risk Grade:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {
                                              allCBSData?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]?.cbs_data?.RiskGrade
                                            }
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Secured Credit Utilized:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {allCBSData
                                              ?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]
                                              ?.cbs_data?.SecuredCreditUtilized?.toLocaleString(
                                                "en-US",
                                                {
                                                  style: "currency",
                                                  currency: "SGD",
                                                },
                                              )}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Secured Credit Utilization in
                                            percentage:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {(Number(
                                              allCBSData?.filter(
                                                (dat2) =>
                                                  dat2?.name ===
                                                  getPersonData(data)?.name?.value,
                                              )?.[0]?.cbs_data
                                                ?.SecuredCreditUtilizationinpercentage,
                                            ) || 0) + "%"}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Monthly Commitment/Installment
                                            Secured:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {(
                                              Number(
                                                allCBSData?.filter(
                                                  (dat2) =>
                                                    dat2?.name ===
                                                    getPersonData(data)?.name?.value,
                                                )?.[0]?.cbs_data
                                                  ?.MonthlyCommitment,
                                              ) || 0
                                            )?.toLocaleString("en-US", {
                                              style: "currency",
                                              currency: "SGD",
                                            })}
                                          </Text>
                                        </View>
                                        <View
                                          style={{
                                            flexDirection: "row",
                                            gap: 10,
                                          }}
                                        >
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                              fontWeight: 700,
                                            }}
                                          >
                                            Bankcruptcy Proceedings:
                                          </Text>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                            }}
                                          >
                                            {allCBSData?.filter(
                                              (dat2) =>
                                                dat2?.name ===
                                                getPersonData(data)?.name?.value,
                                            )?.[0]?.cbs_data
                                              ?.bankcruptcyProceedings
                                              ? "True"
                                              : "N/A"}
                                          </Text>
                                        </View>
                                      </View>
                                    </View>
                                    {allCBSData?.filter(
                                      (dat2) =>
                                        dat2?.name ===
                                        getPersonData(data)?.name?.value,
                                    )?.[0]?.cbs_data?.defaults ? (
                                      <View
                                        style={{
                                          borderLeftWidth: 1,
                                          borderRightWidth: 1,
                                          borderColor: reportTheme.borderBlue,
                                          paddingHorizontal: 8,
                                        }}
                                      >
                                        <View>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                            }}
                                          >
                                            Disclaimer
                                          </Text>
                                        </View>
                                        <View>
                                          <Text
                                            style={{
                                              fontSize: reportBodyFontSize,
                                              fontFamily: "Poppins",
                                            }}
                                          >
                                            Take note that due to the user
                                            having default or bankcruptcy
                                            proceedings the values above might
                                            not be reliable due to the change in
                                            circumstances.
                                          </Text>
                                        </View>
                                      </View>
                                    ) : null}
                                    <View
                                      style={{
                                        padding: 8,
                                        borderColor: reportTheme.borderBlue,
                                        borderLeftWidth: 1,
                                        borderRightWidth: 1,
                                      }}
                                    >
                                      <View
                                        style={{
                                          flexDirection: "row",
                                          width: "100%",
                                          backgroundColor:
                                            reportTheme.headerBlue,
                                          opacity: 0.7,
                                          padding: 4,
                                          gap: 10,
                                        }}
                                      >
                                        <View
                                          style={{
                                            width: "30%",
                                            fontSize: reportBodyFontSize,
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          <Text>Loan / Product Type</Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "30%",
                                            fontSize: reportBodyFontSize,
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          <Text>Grantor / Bank</Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "20%",
                                            fontSize: reportBodyFontSize,
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          <Text>Outstanding Balance</Text>
                                        </View>
                                        <View
                                          style={{
                                            width: "20%",
                                            fontSize: reportBodyFontSize,
                                            fontFamily: "Poppins",
                                          }}
                                        >
                                          <Text>Monthly Installment</Text>
                                        </View>
                                      </View>

                                      {allCBSData
                                        ?.filter(
                                          (dat2) =>
                                            dat2?.name ===
                                            getPersonData(data)?.name?.value,
                                        )?.[0]
                                        ?.cbs_data?.NoteworthyOngoingLoans?.map(
                                          (imp, index10) => (
                                            <View
                                              key={index10}
                                              style={{
                                                flexDirection: "row",
                                                width: "100%",
                                                backgroundColor:
                                                  index10 % 2
                                                    ? reportTheme.rowOdd
                                                    : reportTheme.rowEven,
                                                padding: 4,
                                                gap: 10,
                                              }}
                                            >
                                              <View
                                                style={{
                                                  width: "30%",
                                                  fontSize: reportBodyFontSize,
                                                  fontFamily: "Poppins",
                                                }}
                                              >
                                                <Text>
                                                  {imp.includes(
                                                    "private residential purchase",
                                                    "",
                                                  )
                                                    ? "Private Residential Purchase"
                                                    : imp.includes(
                                                          "motor vehicle loan",
                                                          "",
                                                        )
                                                      ? "Motor Vehicle Loan"
                                                      : imp.includes(
                                                            "hdb loan",
                                                            "",
                                                          )
                                                        ? "HDB Loan"
                                                        : ""}
                                                </Text>
                                              </View>
                                              <View
                                                style={{
                                                  width: "30%",
                                                  fontSize: reportBodyFontSize,
                                                  fontFamily: "Poppins",
                                                }}
                                              >
                                                <Text>
                                                  {imp
                                                    .replace(
                                                      "private residential purchase",
                                                      "",
                                                    )
                                                    .replace(
                                                      "motor vehicle loan",
                                                      "",
                                                    )
                                                    .replace("hdb loan", "")
                                                    .trim()
                                                    .split(" ")[0]
                                                    .toUpperCase()}
                                                </Text>
                                              </View>
                                              <View
                                                style={{
                                                  width: "20%",
                                                  fontSize: reportBodyFontSize,
                                                  fontFamily: "Poppins",
                                                }}
                                              >
                                                <Text>
                                                  {parseFloat(
                                                    imp
                                                      .split("   ")
                                                      [
                                                        imp.split("   ")
                                                          .length - 4
                                                      ].replace(/,/g, ""),
                                                  ).toLocaleString("en-US", {
                                                    style: "currency",
                                                    currency: "SGD",
                                                  })}
                                                </Text>
                                              </View>
                                              <View
                                                style={{
                                                  width: "20%",
                                                  fontSize: reportBodyFontSize,
                                                  fontFamily: "Poppins",
                                                }}
                                              >
                                                <Text>
                                                  {allCBSData?.filter(
                                                    (dat2) =>
                                                      dat2?.name ===
                                                      getPersonData(data)?.name?.value,
                                                  )?.[0]?.cbs_data
                                                    ?.CBSImpLoanSupplementaryInstallment?.[
                                                    index10
                                                  ]
                                                    ? (
                                                        parseFloat(
                                                          allCBSData
                                                            ?.filter(
                                                              (dat2) =>
                                                                dat2?.name ===
                                                                getPersonData(data)
                                                                  ?.name?.value,
                                                            )?.[0]
                                                            ?.cbs_data?.CBSImpLoanSupplementaryInstallment[
                                                              index10
                                                            ].split("   ")
                                                            [
                                                              allCBSData
                                                                ?.filter(
                                                                  (dat2) =>
                                                                    dat2?.name ===
                                                                    getPersonData(data)
                                                                      ?.name
                                                                      ?.value,
                                                                )?.[0]
                                                                ?.cbs_data?.CBSImpLoanSupplementaryInstallment[
                                                                  index10
                                                                ].split("   ")
                                                                .length - 4
                                                            ]?.replace(
                                                              /,/g,
                                                              "",
                                                            ),
                                                        ) +
                                                        parseFloat(
                                                          allCBSData
                                                            ?.filter(
                                                              (dat2) =>
                                                                dat2?.name ===
                                                                getPersonData(data)
                                                                  ?.name?.value,
                                                            )?.[0]
                                                            ?.cbs_data?.CBSImpLoanSupplementaryInstallment[
                                                              index10
                                                            ].split("   ")
                                                            [
                                                              allCBSData
                                                                ?.filter(
                                                                  (dat2) =>
                                                                    dat2?.name ===
                                                                    getPersonData(data)
                                                                      ?.name
                                                                      ?.value,
                                                                )?.[0]
                                                                ?.cbs_data?.CBSImpLoanSupplementaryInstallment[
                                                                  index10
                                                                ].split("   ")
                                                                .length - 3
                                                            ]?.replace(
                                                              /,/g,
                                                              "",
                                                            ),
                                                        )
                                                      ).toLocaleString(
                                                        "en-US",
                                                        {
                                                          style: "currency",
                                                          currency: "SGD",
                                                        },
                                                      )
                                                    : null}
                                                </Text>
                                              </View>
                                            </View>
                                          ),
                                        )}
                                    </View>
                                    <View
                                      style={{
                                        backgroundColor: reportTheme.headerBlue,
                                        alignItems: "center",
                                        padding: 8,
                                        borderTopLeftRadius: 7,
                                        borderTopRightRadius: 7,
                                      }}
                                    >
                                      <Text
                                        style={{
                                          fontSize: reportTitleFontSize,
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                          color: "#ffffff",
                                        }}
                                      >
                                        Last 6 Months (Unsecured) Credit
                                        Utilization Graph
                                      </Text>
                                    </View>
                                    <View
                                      style={{
                                        padding: 8,
                                        borderColor: reportTheme.borderBlue,
                                        borderLeftWidth: 1,
                                        borderRightWidth: 1,
                                        borderBottomWidth: 1,
                                      }}
                                    >
                                      <View
                                        style={{
                                          width: "100%",
                                          fontSize: reportBodyFontSize,
                                        }}
                                      >
                                        <View style={{ flexDirection: "row" }}>
                                          <View
                                            style={{
                                              width: "5%",
                                              position: "relative",
                                            }}
                                          >
                                            <View style={{ height: "15px" }}>
                                              <Text
                                                style={{
                                                  position: "absolute",
                                                  top: 0,
                                                  left: 0,
                                                }}
                                              >
                                                {allCBSData
                                                  ?.filter(
                                                    (dat2) =>
                                                      dat2?.name ===
                                                      getPersonData(data)?.name?.value,
                                                  )?.[0]
                                                  ?.cbs_data?.Last6MonthsGraphChartMaxData?.toLocaleString(
                                                    "en-US",
                                                    {
                                                      style: "currency",
                                                      currency: "SGD",
                                                    },
                                                  )}
                                              </Text>
                                            </View>
                                            <View
                                              style={{ height: "220px" }}
                                            ></View>
                                          </View>
                                          <View
                                            style={{
                                              width: "95%",
                                            }}
                                          >
                                            <View
                                              style={{
                                                width: "100%",
                                                flexDirection: "row",
                                                marginTop: "25px",
                                                borderBottom:
                                                  "1px solid lightgrey",
                                                height: "200px",
                                                alignItems: "flex-end",
                                              }}
                                            >
                                              <View
                                                style={{
                                                  height: "200px",
                                                  borderLeft:
                                                    "1px solid lightgrey",
                                                }}
                                              />
                                              {allCBSData
                                                ?.filter(
                                                  (dat2) =>
                                                    dat2?.name ===
                                                    getPersonData(data)?.name?.value,
                                                )?.[0]
                                                ?.cbs_data?.Last6MonthsGraphChartData?.map(
                                                  (dat30, index30) => (
                                                    <View
                                                      key={index30}
                                                      style={{
                                                        marginLeft: "4%",
                                                        marginRight: "4%",
                                                        width: "8%",
                                                        borderTopLeftRadius:
                                                          "4px",
                                                        borderTopRightRadius:
                                                          "4px",
                                                        height: `${
                                                          (parseFloat(
                                                            dat30.value.replace(
                                                              /,/g,
                                                              "",
                                                            ),
                                                          ) /
                                                            allCBSData?.filter(
                                                              (dat2) =>
                                                                dat2?.name ===
                                                                getPersonData(data)
                                                                  ?.name?.value,
                                                            )?.[0]?.cbs_data
                                                              ?.Last6MonthsGraphChartMaxData) *
                                                          100
                                                        }%`,
                                                        backgroundColor:
                                                          "#f0eeff",
                                                      }}
                                                    ></View>
                                                  ),
                                                )}
                                            </View>
                                            <View
                                              style={{
                                                marginTop: "8px",
                                                flexDirection: "row",
                                                fontSize: reportBodyFontSize,
                                              }}
                                            >
                                              {allCBSData
                                                ?.filter(
                                                  (dat2) =>
                                                    dat2?.name ===
                                                    getPersonData(data)?.name?.value,
                                                )?.[0]
                                                ?.cbs_data?.Last6MonthsGraphChartData?.map(
                                                  (dat, index) => (
                                                    <View
                                                      key={index}
                                                      style={{
                                                        width: "16%",
                                                        textAlign: "center",
                                                      }}
                                                    >
                                                      <Text
                                                        style={{
                                                          fontWeight: 600,
                                                          fontSize:
                                                            reportBodyFontSize,
                                                        }}
                                                      >
                                                        {dat.date
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                          dat.date.slice(1)}
                                                      </Text>
                                                      <Text
                                                        style={{
                                                          fontWeight: 600,
                                                          fontSize:
                                                            reportBodyFontSize,
                                                        }}
                                                      >
                                                        {parseFloat(
                                                          dat.value.replace(
                                                            /,/g,
                                                            "",
                                                          ),
                                                        ).toLocaleString(
                                                          "en-US",
                                                          {
                                                            style: "currency",
                                                            currency: "SGD",
                                                          },
                                                        )}
                                                      </Text>
                                                    </View>
                                                  ),
                                                )}
                                            </View>
                                          </View>
                                        </View>
                                      </View>
                                    </View>
                                  </View>
                                </>
                              ) : null}
                            </View>
                          </Page>
                        ))
                      : null}
                    {bankAnalysisContext?.loanType === "personal" ? (
                      <Page size="A4">
                        {renderPdfHeader("")}
                        <View style={{ paddingHorizontal: 28 }}>
                          {renderPersonalCbsReport()}
                        </View>
                      </Page>
                    ) : null}
                    {bankAnalysisContext?.enabled &&
                    bankAnalysisState.statements.length > 0 ? (
                      <Page size="A4">
                        {renderPdfHeader("Customer Document Analysis")}
                        {renderBankAnalysisPdf()}
                      </Page>
                    ) : null}
                    {mlcbAnalysisContext?.enabled &&
                    mlcbAnalysisState.entries.length > 0 ? (
                      <Page size="A4">
                        {renderPdfHeader("MLCB Analysis")}
                        {renderMlcbAnalysisPdf()}
                      </Page>
                    ) : null}
                  </Document>
                </PDFViewer>
              </div>
            )
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default ProfileViewer;
